<template>
  <el-container class="box">
    <div class="header">
      <div class="text"><span>机构组织 / </span><span>医护信息</span></div>
      <div class="top-tabs">
        <div :class="activeName1 == 1 ? 'tabs-cliked' : ''" @click="handleTabClick(1)">
          <span>基本信息</span>
        </div>
        <div :class="activeName1 == 2 ? 'tabs-cliked' : ''" @click="handleTabClick(2)">
          <span>资质信息上传</span>
        </div>
        <div v-if="information1.doctorType == 1" :class="activeName1 == 3 ? 'tabs-cliked' : ''"
          @click="handleTabClick(3)">
          <span>问诊配置</span>
        </div>
      </div>
    </div>
    <el-main class="content">
      <div v-if="activeName1 === 1" key="100">
        <div class="line-div">
          <span></span>
          <span>
            基本信息
          </span>
          <span class="user-id">用户ID：{{information1.userId}}</span>
        </div>
        <template v-if="isEdit1">
          <el-form ref="addForm" @submit.native.prevent :model="information1" label-width="140px"
            :rules="isEdit1 ? rules : {}" size="small">
            <el-form-item label="医护照片: " required>
              <BaseUploadFile :fileSize="6" :isShowTip="false" :cropWidth="100" :cropHeight="100" :size="60"
                :action="VUE_APP_BASE_URL" :responseFn="handleMessageResponse2" :data="{ path: 'dsicm-doctor' }"
                v-model="upavater">
              </BaseUploadFile>
            </el-form-item>
            <el-row>
              <el-col :span="12">
                <el-form-item label="姓名: " prop="realName">
                  <el-input :disabled="
                    information1.sourceType == 2 &&
                      !doctorCertificateSubmitDTO.idCard.front
                      ? false
                      : true
                  " v-model.trim="information1.realName" placeholder="请输入你的真实姓名">
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="手机号: " prop="mobile">
                  <el-input maxlength="11" disabled v-model="information1.mobile" placeholder="请输入11位有效数字 "></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="医护类型: " disabled prop="doctorType">
                  <el-select disabled v-model="information1.doctorType" placeholder="请选择医护类型"
                    @change="selectDoctorType">
                    <el-option label="医生" :value="1"></el-option>
                    <el-option label="护士" :value="2"></el-option>
                    <!-- <el-option v-if="userPlatForm == 'platForm'" label="药师" :value="4"></el-option> -->
                    <el-option label="药师" :value="4"></el-option>
                    <el-option label="医辅" :value="6"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="职称: " prop="titleId">
                  <el-select v-model="information1.titleId" @change="doctorTitleChange" placeholder="请选择职称">
                    <el-option v-for="(item, index) in doctorTitleList" :key="index" :label="item.name"
                      :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <!-- <el-row>
              <el-col :span="12">
                <el-form-item label="身份证号: " prop="idCard">
                  <el-input :disabled="
                      information1.sourceType == 2 &&
                      !doctorCertificateSubmitDTO.idCard.front
                        ? false
                        : true
                    " v-model="information1.idCard" placeholder="请输入你的身份证号码"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12" v-if="userPlatForm == 'platForm'">
                <el-form-item label="线下机构: " placeholder="请输入关键词搜索线下机构" prop="hospitalId" :rules="
                    information1.doctorType == 4
                      ? [{ required: false }]
                      : [
                          {
                            required: true,
                            message: '请选择线下机构',
                            trigger: 'change'
                          }
                        ]
                  ">
                  <el-select :disabled="
                      information1.sourceType == 2 &&
                      !doctorCertificateSubmitDTO.idCard.front
                        ? false
                        : crolBtn
                    " v-model="information1.hospitalId" clearable filterable @change="hospitalChange">
                    <el-option v-for="(item, index) in hospitalList" :disabled="item.disabled" :key="index"
                      :label="item.name" :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="线下科室: " prop="departmentId" :rules="
                    information1.doctorType == 4
                      ? [{ required: false }]
                      : [
                          {
                            required: true,
                            message: '请选择线下科室',
                            trigger: 'change'
                          }
                        ]
                  ">
                  <el-cascader ref="Mycascader" @change="departmentChange()" filterable placeholder="请输入关键词搜索线下科室"
                    v-model="information1.departmentId" :options="departmentList" clearable :props="SetKesDept">
                  </el-cascader>
                </el-form-item>
              </el-col>
              <el-col :span="12" v-if="information1.doctorType == '1'">
                <el-form-item label="服务病种: " prop="diseaseServingDTOList">

                  <el-select v-model="information1.diseaseServingDTOList" clearable filterable multiple
                    @change="diseaseChange" value-key="diseaseTypeId" placeholder="请选择服务病种">
                    <el-option v-for="(item, index) in diseaseList" :key="index" :label="item.diseaseTypeName"
                      :value="item"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row> -->

            <!-- 新加 -->
            <el-row>
              <el-col :span="12">
                <el-form-item label="身份证号: " prop="idCard">
                  <el-input v-model="information1.idCard"
                    :disabled="information1.sourceType == 2 && !doctorCertificateSubmitDTO.idCard.front ? false : true"
                    placeholder="请输入你的身份证号码">
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12" v-if="information1.doctorType == '1'">
                <el-form-item label="服务病种: " prop="diseaseServingDTOList">
                  <el-select v-model="information1.diseaseServingDTOList" clearable filterable multiple
                    @change="diseaseChange" value-key="diseaseTypeId" placeholder="请选择服务病种">
                    <el-option v-for="(item, index) in diseaseList" :key="index" :label="item.diseaseTypeName"
                      :value="item"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-if="information1.doctorType == '6' && userPlatForm == 'platForm'">
              <el-col :span="12">
                <el-form-item label="是否为平台医辅：" prop="platformAssist">
                  <!-- <el-radio-group v-model="information1.platformAssist" size="small">
                    <el-radio-button :label='1'>是</el-radio-button>
                    <el-radio-button :label='0'>否</el-radio-button>
                  </el-radio-group> -->
                  <el-radio v-model="information1.platformAssist" label="1" :disabled="true"
                    @change="platformAssistChange">是
                  </el-radio>
                  <el-radio v-model="information1.platformAssist" label="0" :disabled="true"
                    @change="platformAssistChange">否
                  </el-radio>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-if="information1.platformAssist == '1' && information1.doctorType == 6">
              <el-col :span="12" v-if="
                userPlatForm == 'platForm' && information1.doctorType == 6
              ">
                <!-- multiple -->
                <el-form-item label="">
                  <el-button type="primary" @click="addHospitalId">+ 添加机构</el-button>
                  <el-button type="primary" @click="confirmClick">确认</el-button>
                </el-form-item>
              </el-col>
            </el-row>
            <div v-if="information1.platformAssist == '1' && userPlatForm == 'platForm'">
              <el-row v-for="(insit, insitIndex) in information1.hospitalList" :key="insitIndex">
                <el-col :span="8" v-if="
                  userPlatForm == 'platForm' && information1.doctorType != 4
                ">
                  <el-form-item label="线下机构: " required>
                    <el-select v-model="insit.hospitalId" filterable @change="hospitalChangeNew($event, insitIndex)"
                      placeholder="请输入关键词搜索线下机构">
                      <el-option v-for="(item, index) in hospitalList" :key="index" :label="item.name" :value="item.id"
                        :disabled="item.flag">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8" v-if="information1.doctorType != 4">
                  <el-form-item label="线下科室: " required>
                    <el-cascader :ref="'Mycascader' + insitIndex" @change="departmentChangeNew($event, insitIndex)"
                      :key="insit.hospitalId" filterable placeholder="请输入关键词搜索线下科室" v-model="insit.departmentId"
                      :options="insit.departmentList" :props="SetKesDeptNew">
                    </el-cascader>
                  </el-form-item>
                </el-col>
                <el-col :span="4" v-if="information1.hospitalList.length > 1">
                  <img src="../../assets/images/delete-hospital-icon.png"
                    style="width:20px;height:20px;margin:10px 0 0 30px;cursor: pointer;"
                    @click="deleteClick(insitIndex)" alt="">
                </el-col>
              </el-row>
            </div>
            <!-- v-if="information1.platformAssist == '0' && userPlatForm == 'platForm' && information1.doctorType == 6" -->
            <!-- 医生，护士，非平台衣服不可编辑  -->
            <div v-if="information1.doctorType == '6'">
              <div v-for="(insit, insitIndex) in information1.hospitalList" :key="insitIndex">
                <el-row>
                  <el-col :span="12" v-if="
                    information1.platformAssist == '0' && userPlatForm == 'platForm'
                  ">
                    <el-form-item label="线下机构: " required>
                      <el-select v-model="insit.hospitalId" clearable filterable
                        @change="hospitalChangeNew($event, insitIndex)" placeholder="请输入关键词搜索线下机构" :disabled="
                          information1.sourceType == 2 &&
                            !doctorCertificateSubmitDTO.idCard.front
                            ? false
                            : crolBtn
                        ">
                        <el-option v-for="(item, index) in hospitalList" :key="index" :label="item.name"
                          :value="item.id">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row v-if="information1.platformAssist == '0'">
                  <el-col :span="12" v-if="information1.doctorType != 4">
                    <el-form-item label="线下科室: " required>
                      <el-cascader :ref="'Mycascader' + insitIndex"
                        @change="departmentChangeNewMent($event, insitIndex)" filterable placeholder="请输入关键词搜索线下科室"
                        v-model="insit.departmentId" :options="insit.departmentList" clearable :props="SetKesDept">
                      </el-cascader>
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>
            </div>
            <div v-else>
              <el-row>
                <el-col :span="12" v-if="
                  information1.platformAssist == '0' && userPlatForm == 'platForm'
                ">
                  <el-form-item label="线下机构: " prop="hospitalId" :rules="{
                    required: true,
                    message: '请选择线下机构',
                    trigger: 'change'
                  }">
                    <el-select v-model="information1.hospitalId" clearable filterable @change="hospitalChange"
                      placeholder="请输入关键词搜索线下机构" :disabled="
                        information1.sourceType == 2 &&
                          !doctorCertificateSubmitDTO.idCard.front
                          ? false
                          : crolBtn
                      ">
                      <el-option v-for="(item, index) in hospitalList" :key="index" :label="item.name" :value="item.id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row v-if="information1.platformAssist == '0'">
                <el-col :span="12">
                  <el-form-item label="线下科室: " prop="departmentId" :rules="{
                    required: true,
                    message: '请选择线下科室',
                    trigger: 'change'
                  }">
                    <el-cascader ref="Mycascader" @change="departmentChange()" filterable placeholder="请输入关键词搜索线下科室"
                      v-model="information1.departmentId" :options="departmentList" clearable :props="SetKesDept">
                    </el-cascader>
                  </el-form-item>
                </el-col>
              </el-row>

            </div>
            <!-- 新加 -->
            <el-row>
              <el-col :span="14" v-if="information1.diseaseServingDTOList && information1.diseaseServingDTOList.length">
                <el-form-item label="公众号配图: " required>
                  <BaseUploadFile :fileSize="10" :isShowTip="false" :cropWidth="250" :cropHeight="200"
                    message="建议上传宽度像素：500；建议图片长宽比为5:4" :size="60"
                    action="/api/dsicm-contact-platform/feign/file/wechat/upload/app-id-list"
                    :responseFn="handleSharingPicUrlResponse"
                    :data="{ path: 'dsicm-doctor', wechatMediaIdList: JSON.stringify(wxUploadList), type: 'image', hospitalId: hospitalId }"
                    v-model="information1.sharingPicUrl">
                  </BaseUploadFile>
                </el-form-item>
              </el-col>
            </el-row>

            <el-form-item label="服务寄语: " prop="serviceWishes" v-if="information1.doctorType == '1'">
              <el-input maxlength="200" show-word-limit v-model="information1.serviceWishes" placeholder="请输入服务寄语"
                type="textarea" resize="none"></el-input>
            </el-form-item>

            <el-form-item label="专业擅长: " prop="professional" v-if="information1.doctorType == 1">
              <el-input v-model="information1.professional" placeholder="请输入专业擅长" type="textarea" resize="none">
              </el-input>
            </el-form-item>
            <el-form-item label="医生介绍: " prop="note" v-if="information1.doctorType == 1">
              <el-input resize="none" type="textarea" placeholder="请输入医生介绍" v-model="information1.note">
              </el-input>
            </el-form-item>
            <el-form-item label="护士上门服务: " prop="provideNursingService" v-if="information1.doctorType == 2">
              <el-radio-group v-model="information1.provideNursingService" @change="redioChange()">
                <el-radio :label="true">是</el-radio>
                <el-radio :label="false">否</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="护士上门服务地理范围(KM): " class="lH20" prop="serviceScopeKm" v-if="
              information1.doctorType == 2 &&
              information1.provideNursingService
            ">
              <div style="display:flex">
                <el-input v-model.trim="information1.serviceScopeKm" @input="inputNumber" placeholder="请输入数值">
                </el-input>
                <div style="color:red;width:300px;font-size:12px">
                  （以归属医院地址为中心点）
                </div>
              </div>
            </el-form-item>
          </el-form>
        </template>
        <template v-else>
          <el-form @submit.native.prevent :model="information1" label-width="100px">
            <el-form-item label="医护照片: ">
              <el-image style="width: 60px; height: 60px;margin-right:10px" :src="upavater" :z-index="2003">
                <div slot="error" class="image-slot">
                  <img src="@/assets/images/noImage.svg" />
                </div>
              </el-image>
            </el-form-item>
            <el-row>
              <el-col :span="12">
                <el-form-item label="姓名: " prop="realName">
                  <span>{{ information1.realName }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="手机号: " prop="mobile">
                  <span>{{ information1.mobile }}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="医护类型: " prop="doctorType">
                  <span>{{
                    information1.doctorType == 1
                      ? "医生"
                      : information1.doctorType == 2
                        ? "护士"
                        : information1.doctorType == 6
                          ? "医辅"
                          : "药师"
                  }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="职称: " prop="titleName">
                  <span>{{
                    information1.titleName ? information1.titleName : "暂无数据"
                  }}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="身份证号: " prop="idCard">
                  <span>{{ information1.idCard }}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <!-- <el-row v-if="information1.doctorType == 6 && information1.platformAssist == 1"> -->
            <el-row v-if="information1.doctorType == 6">
              <!-- 医辅 -->
              <el-col :span="24" v-for="el in information1.hospitalListNew" :key="el.hospitalId">
                <div>
                  <el-form-item class="form-box mb10" label="线下机构: " placeholder="请选择线下机构" prop="hospitalName"
                    v-show="userPlatForm != 'organization'">
                    <span>{{
                      el.hospitalName
                        ? el.hospitalName
                        : "暂无数据"
                    }}</span>
                  </el-form-item>
                  <!-- mmm -->
                  <el-form-item class="form-box" label="线下科室: " prop="departmentName">
                    <p style="display:inline-block" v-for="(itemHos, itemIndex) in el.openDepartmentIdList"
                      :key="itemHos.openDepartmentId">{{
  itemIndex == el.openDepartmentIdList.length - 1 && itemHos.openDepartmentName ||
  (itemHos.openDepartmentName + ',')
                      }}</p>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
            <el-row v-else>
              <el-col :span="12" v-if="userPlatForm == 'platForm'">
                <el-form-item class="form-box mb10" label="线下机构: " placeholder="请选择线下机构" prop="hospitalName">
                  <span>{{
                    information1.hospitalName
                      ? information1.hospitalName
                      : "暂无数据"
                  }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item class="form-box" label="线下科室: " prop="departmentName">
                  <span>{{
                    information1.departmentName
                      ? information1.departmentName
                      : "暂无数据"
                  }}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <!-- <el-col :span="12">
                <el-form-item label="线下科室: " prop="departmentName">
                  <span>{{
                    information1.departmentName
                      ? information1.departmentName
                      : "暂无数据"
                  }}</span>
                </el-form-item>
              </el-col> -->
              <el-col :span="12" v-if="information1.doctorType == '1'">
                <el-form-item label="服务病种: ">
                  <span>{{
                    information1.diseaseTypeNames
                      ? information1.diseaseTypeNames
                      : "暂无数据"
                  }}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="14" v-if="information1.diseaseServingDTOList && information1.diseaseServingDTOList.length">
                <el-form-item label="公众号配图: ">

                  <el-image style="width: 60px; height: 60px;margin-right:10px" :src="information1.sharingPicUrl"
                    :z-index="2003">
                    <div slot="error" class="image-slot">
                      <img src="@/assets/images/noImage.svg" />
                    </div>
                  </el-image>

                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item label="服务寄语: " prop="serviceWishes" v-if="information1.doctorType == 1">

              <span style="overflow-wrap: anywhere">{{
                information1.serviceWishes
                  ? information1.serviceWishes
                  : "暂无数据"
              }}</span>
            </el-form-item>
            <el-form-item label="专业擅长: " prop="professional" v-if="information1.doctorType == 1">
              <span>{{
                information1.professional
                  ? information1.professional
                  : "暂无数据"
              }}</span>
            </el-form-item>
            <el-form-item label="医生介绍: " prop="note" v-if="information1.doctorType == 1">
              <span>{{
                information1.note ? information1.note : "暂无数据"
              }}</span>
            </el-form-item>
            <el-form-item label="护士上门服务: " v-if="information1.doctorType == 2" prop="provideNursingService">
              <span>{{
                information1.provideNursingService ? "是" : "否"
              }}</span>
            </el-form-item>
            <el-form-item label="护士上门服务地理范围(KM): " class="lH20" prop="serviceScopeKm" v-if="
              information1.doctorType == 2 &&
              information1.provideNursingService
            ">
              <span>{{
                information1.serviceScopeKm
                  ? information1.serviceScopeKm
                  : "暂无数据"
              }}</span>
            </el-form-item>
          </el-form>
        </template>

        <div class="line-div">
          <span></span>
          <span>
            归属团队
          </span>
        </div>
        <template>
          <div class="team-item" v-if="joinedTeamList.length == 0"
            style="font-weight: 600;font-size: 12px;line-height: 20px;">
            暂无团队
          </div>
          <el-scrollbar class="self-scroll" v-else ref="chatScroll" style="height:400px"
            wrap-style="overflow-x:hidden;">
            <!-- <div class="team-item"  v-for="items in joinedTeamList"  :key="items.id" v-show="items.leader">
            <h3 style="font-weight: 600;color: #1A7BFC;line-height: 20px;">
              独立团队
            </h3>
            <ul>
              <li>
                <label>团队名称：</label>
                <p>{{ items.teamName ? items.teamName : "暂无数据" }}</p>
              </li>
              <li v-if="userPlatForm == 'platForm'">
                <label>线下机构：</label>
                <p>
                  {{
                    items.teamHospitalName ? items.teamHospitalName : "暂无数据"
                  }}
                </p>
              </li>
              <li>
                <label>线下科室：</label>
                <p>
                  {{
                    items.teamDepartmentName
                      ? items.teamDepartmentName
                      : "暂无数据"
                  }}
                </p>
              </li>
              <li>
                <label>个案组：</label>
                <p>
                  {{
                    items.caseMgrGroupName ? items.caseMgrGroupName : "暂无数据"
                  }}
                </p>
              </li>
            </ul>
          </div> -->
            <div class="team-item" v-for="(items, index) in joinedTeamList" :key="index + 1">
              <h3 style="font-weight: 600;color: #1A7BFC;line-height: 20px;">
                <span v-if="items.leader">独立团队</span>
                <span v-else>归属团队</span>
              </h3>
              <ul>
                <li>
                  <label>团队名称：</label>
                  <p>{{ items.teamName }}</p>
                </li>
                <li v-if="userPlatForm == 'platForm'">
                  <label>线下机构：</label>
                  <p>
                    {{
                      items.teamHospitalName ? items.teamHospitalName : "暂无数据"
                    }}
                  </p>
                </li>
                <li>
                  <label>线下科室：</label>
                  <p>
                    {{
                      items.teamDepartmentName
                        ? items.teamDepartmentName
                        : "暂无数据"
                    }}
                  </p>
                </li>
                <li>
                  <label>个案组：</label>
                  <p>
                    {{
                      items.caseMgrGroupName ? items.caseMgrGroupName : "暂无数据"
                    }}
                  </p>
                </li>
              </ul>
            </div>
          </el-scrollbar>
        </template>
        <span class="dialog-footer" v-if="!isEdit1">
          <el-button class="dialog-btn" size="small"
            :disabled="information1.platformAssist == 1 && certificateStatus == 2 && information1.doctorType == 6"
            type="primary" @click="
  isEdit1 = true;
crolBtn = true;
            ">去编辑</el-button>
        </span>
        <span class="dialog-footer" v-if="isEdit1">
          <!-- <el-button class="dialog-btn" size="small" @click="closeaddCare4()"
            >重置</el-button
          > -->
          <el-button class="dialog-btn" v-preventReClick size="small" type="primary"
            @click="submiAddCare4('addForm')">保存</el-button>
        </span>
      </div>
      <div v-if="activeName1 == 2" key="300" class="info-upload">
        <div class="line-div">
          <span></span>
          <span>
            资质信息上传
          </span>
        </div>
        <el-form label-width="150px" ref="infoUpload" :rules="{}" :model="doctorCertificateSubmitDTO"
          @submit.native.prevent size="small">
          <template v-if="isEdit3">
            <el-row>
              <el-col :span="24" class="label-circle">
                <span>身份证</span>
                <span></span>
              </el-col>
            </el-row>
            <el-row style="margin-bottom: 10px;">
              <el-col :span="12">
                <el-form-item label="国徽面：" required>
                  <BaseUploadFile :multiple="false" :fileSize="6" :isShowTip="false" :cropWidth="279" :cropHeight="138"
                    :size="279" :height="138" :action="VUE_APP_BASE_URL1" :beforeRemove="handleMessage3beforeRemove"
                    :responseFn="handleMessageResponse3" :data="{ path: 'dsicm-doctor' }"
                    v-model="doctorCertificateSubmitDTO.idCard.back">
                  </BaseUploadFile>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="头像面：" required>
                  <BaseUploadFile :multiple="false" :fileSize="6" :isShowTip="false" :cropWidth="100" :cropHeight="100"
                    :size="279" :height="138" :action="VUE_APP_BASE_URL1" :beforeRemove="handleMessage4beforeRemove"
                    :responseFn="handleMessageResponse4" :data="{ path: 'dsicm-doctor' }"
                    v-model="doctorCertificateSubmitDTO.idCard.front">
                  </BaseUploadFile>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24" class="label-circle">
                <span>资格证</span>
                <span></span>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="发证日期：" required>
                  <el-date-picker style="width: 100%;" v-model="doctorCertificateSubmitDTO.qualification.obtainDate" type="date" value-format="yyyy-MM-dd" placeholder="选择发证日期">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="证书编号: " required>
                  <el-input maxlength="50" v-model="doctorCertificateSubmitDTO.qualification.number"
                    placeholder="请输入证书编号"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row style="margin-bottom: 8px;">
              <el-col :span="24" class="tip-zhengshu">
                <el-form-item label="上传图片：" required>
                  <!-- <el-image
							    
							    style="width: 60px; height: 60px;margin-right:10px"
							    v-for="(item,index) in practice.files" :key="index"
							    :src="item" 
							    :z-index="2003"
							    :preview-src-list="practice.files">
							  </el-image> -->
                  <BaseUploadFile :fileSize="6" :size="60" :multiple="false" :limit="9" :isShowTip="false"
                    message="* 最少上传2张，最多上传9张" :checkMore="true" :beforeRemove="certificateQualificationbeforeRemove"
                    :responseFn="certificateQualificationResponse" :action="VUE_APP_BASE_URL1"
                    :data="{ path: 'dsicm-doctor' }" v-model="doctorCertificateSubmitDTO.qualification.files">
                  </BaseUploadFile>
                </el-form-item>
                <!-- <span>* 最少上传2张，最多上传9张</span> -->
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24" class="label-circle">
                <span>执业证</span>
                <span></span>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="发证日期：" required>
                  <el-date-picker style="width: 100%;" v-model="doctorCertificateSubmitDTO.practice.obtainDate"
                    type="date" value-format="yyyy-MM-dd" placeholder="选择发证日期">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="证书编号: " required>
                  <el-input maxlength="50" v-model="doctorCertificateSubmitDTO.practice.number" placeholder="请输入证书编号">
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row style="margin-bottom: 8px;">
              <el-col :span="24" class="tip-zhengshu">
                <el-form-item label="上传图片：" required>
                  <!-- <el-image
							    
							    style="width: 60px; height: 60px;margin-right:10px"
							    v-for="(item,index) in practice.files" :key="index"
							    :src="item" 
							    :z-index="2003"
							    :preview-src-list="practice.files">
							  </el-image> -->
                  <BaseUploadFile :fileSize="6" :multiple="false" :size="60" :limit="9" :isShowTip="false"
                    message="* 最少上传2张，最多上传9张" :checkMore="true" :beforeRemove="practicebeforeRemove"
                    :responseFn="practiceUploadImage" :action="VUE_APP_BASE_URL1" :data="{ path: 'dsicm-doctor' }"
                    v-model="doctorCertificateSubmitDTO.practice.files">
                  </BaseUploadFile>
                </el-form-item>
                <!-- <span>* 最少上传2张，最多上传9张</span> -->
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24" class="label-circle">
                <span>职称证</span><span></span>
              </el-col>
            </el-row>
            <el-row style="margin-bottom: 8px;">
              <el-col :span="24">
                <el-form-item label="上传图片：">
                  <BaseUploadFile :fileSize="6" :checkMore="true" :limit="9" :multiple="false" :size="60"
                    :isShowTip="false" :responseFn="certificatePracticeResponse"
                    :beforeRemove="certificatePracticebeforeRemove" :action="VUE_APP_BASE_URL1"
                    :data="{ path: 'dsicm-doctor' }" v-model="doctorCertificateSubmitDTO.title.files">
                  </BaseUploadFile>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="24" class="label-circle">
                <span>胸牌</span><span></span>
              </el-col>
            </el-row>
            <el-row style="margin-bottom: 8px;">
              <el-col :span="24">
                <el-form-item label="上传图片：" :required="information1.doctorType === 6 ? false : true">
                  <BaseUploadFile :fileSize="6" message="* 最少上传1张，最多上传9张" :checkMore="true" :limit="9" :multiple="false"
                    :size="60" :isShowTip="false" :responseFn="certificateNameBadgeResponse"
                    :beforeRemove="certificateNameBadgebeforeRemove" :action="VUE_APP_BASE_URL1"
                    :data="{ path: 'dsicm-doctor' }" v-model="doctorCertificateSubmitDTO.nameBadge.files">
                  </BaseUploadFile>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24" class="label-circle">
                <span>其他相关资格证</span><span></span>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="上传图片：">
                  <!-- <el-image v-show="isEdit" style="width: 100px; height: 100px;margin-right:10px"
											v-for="(item,index) in other.files" :key="index" :src="item" :z-index="2003"
											:preview-src-list="other.files">
										</el-image> -->
                  <BaseUploadFile :fileSize="6" :limit="9" :checkMore="true" :multiple="false" :size="60"
                    :isShowTip="false" :responseFn="certificateOtherUplod" :beforeRemove="certificateOtherbeforeRemove"
                    :action="VUE_APP_BASE_URL1" :data="{ path: 'dsicm-doctor' }"
                    v-model="doctorCertificateSubmitDTO.other.files">
                  </BaseUploadFile>
                </el-form-item>
              </el-col>
            </el-row>
          </template>
          <template v-else>
            <el-row>
              <el-col :span="24" class="label-circle">
                <span>身份证</span>
                <span></span>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="国徽面：">
                  <el-image style="width: 280px; height: 138px;" :src="doctorCertificateSubmitDTO.idCard.watermarkBack"
                    :z-index="2003" :preview-src-list="[
                      doctorCertificateSubmitDTO.idCard.watermarkBack
                    ]">
                  </el-image>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="头像面：">
                  <el-image style="width: 280px; height: 138px;" :src="doctorCertificateSubmitDTO.idCard.watermarkFront"
                    :z-index="2003" :preview-src-list="[
                      doctorCertificateSubmitDTO.idCard.watermarkFront
                    ]">
                  </el-image>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24" class="label-circle">
                <span>资格证</span><span></span>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="发证日期：">
                  {{
                    doctorCertificateSubmitDTO.qualification.obtainDate
                      ? doctorCertificateSubmitDTO.qualification.obtainDate
                      : "暂无数据"
                  }}
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="证书编号: ">
                  <span>{{
                    doctorCertificateSubmitDTO.qualification.number
                      ? doctorCertificateSubmitDTO.qualification.number
                      : "暂无数据"
                  }}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="上传图片：">
                  <el-image style="width: 60px; height: 60px;margin-right:10px" v-for="(item, index) in doctorCertificateSubmitDTO
                  .qualification.fileList" :key="index" :src="item" :z-index="2003" :preview-src-list="
    doctorCertificateSubmitDTO.qualification.fileList
  ">
                  </el-image>
                  <template v-if="
                    !doctorCertificateSubmitDTO.qualification.fileList ||
                    doctorCertificateSubmitDTO.qualification.fileList
                      .length == 0
                  ">暂无数据</template>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24" class="label-circle">
                <span>执业证</span><span></span>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="发证日期：">
                  {{
                    doctorCertificateSubmitDTO.practice.obtainDate
                      ? doctorCertificateSubmitDTO.practice.obtainDate
                      : "暂无数据"
                  }}
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="证书编号: ">
                  <span>{{
                    doctorCertificateSubmitDTO.practice.number
                      ? doctorCertificateSubmitDTO.practice.number
                      : "暂无数据"
                  }}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="上传图片：">
                  <el-image style="width: 60px; height: 60px;margin-right:10px" v-for="(item, index) in doctorCertificateSubmitDTO.practice
                  .fileList" :key="index" :src="item" :z-index="2003" :preview-src-list="
    doctorCertificateSubmitDTO.practice.fileList
  ">
                  </el-image>
                  <span v-if="
                    !doctorCertificateSubmitDTO.practice.fileList ||
                    doctorCertificateSubmitDTO.practice.fileList.length == 0
                  ">暂无数据</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24" class="label-circle">
                <span>职称证</span><span></span>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="上传图片：">
                  <el-image style="width: 100px; height: 100px;margin-right:10px" v-for="(item, index) in doctorCertificateSubmitDTO.title
                  .fileList" :key="index" :src="item" :z-index="2003" :preview-src-list="
    doctorCertificateSubmitDTO.title.fileList
  ">
                  </el-image>
                  <span v-if="
                    !doctorCertificateSubmitDTO.title.fileList ||
                    doctorCertificateSubmitDTO.title.fileList.length == 0
                  ">暂无数据</span>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="24" class="label-circle">
                <span>胸牌</span><span></span>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="上传图片：">
                  <el-image style="width: 100px; height: 100px;margin-right:10px" v-for="(item, index) in doctorCertificateSubmitDTO.nameBadge
                  .fileList" :key="index" :src="item" :z-index="2003" :preview-src-list="
    doctorCertificateSubmitDTO.nameBadge.fileList
  ">
                  </el-image>
                  <span v-if="
                    !doctorCertificateSubmitDTO.nameBadge.fileList ||
                    doctorCertificateSubmitDTO.nameBadge.fileList.length ==
                    0
                  ">暂无数据</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24" class="label-circle">
                <span>其他相关资格证</span><span></span>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="上传图片：">
                  <el-image style="width: 100px; height: 100px;margin-right:10px" v-for="(item, index) in doctorCertificateSubmitDTO.other
                  .fileList" :key="index" :src="item" :z-index="2003" :preview-src-list="
    doctorCertificateSubmitDTO.other.fileList
  ">
                  </el-image>
                  <span v-if="
                    !doctorCertificateSubmitDTO.other.fileList ||
                    doctorCertificateSubmitDTO.other.fileList.length == 0
                  ">暂无数据</span>
                </el-form-item>
              </el-col>
            </el-row>
          </template>
        </el-form>
        <span class="dialog-footer" v-if="!isEdit3">
          <el-button class="dialog-btn" size="small" type="primary" @click="isEdit3 = true">去编辑</el-button>
        </span>
        <span class="dialog-footer" v-if="isEdit3">
          <!-- <el-button class="dialog-btn" size="small" @click="closeaddCare5()"
            >重置</el-button
          > -->
          <el-button class="dialog-btn" size="small" type="primary" @click="submiAddCare5('addForm')">保存</el-button>
        </span>
      </div>
      <div v-if="activeName1 == 3">
        <div class="line-div">
          <span></span>
          <span>
            问诊配置
          </span>
        </div>
        <template v-if="isEdit2">
          <el-form ref="cnForm" @submit.native.prevent :model="information2" label-width="140px" :rules="rules1" size="small">
            <el-form-item label="开启图文问诊: " prop="disabled">
              <el-radio-group v-model="information2.disabled" @change="disabledChanged">
                <el-radio :label="false">是</el-radio>
                <el-radio :label="true">否</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="开启义诊: " prop="disabled">
              <el-radio-group v-model="information2.freeClinicsDisabled" :disabled="information2.disabled == true">
                <el-radio :label="false">是</el-radio>
                <el-radio :label="true">否</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-row>
              <el-col :span="14">
                <el-form-item v-if="!information2.disabled" label="咨询费: " prop="consultFee">
                  <el-input type="text" v-model.trim="information2.consultFee" placeholder="请输入咨询费">
                    <template slot="append">元</template>
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="14">
                <el-form-item v-if="!information2.disabled" label="服务时长: " prop="serviceTime">
                  <el-input type="text" v-model.trim="information2.serviceTime" placeholder="请输入服务时长">
                    <template slot="append">小时</template>
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col>
                <el-form-item v-if="!information2.disabled" label="咨询简介: " prop="describe">
                  <el-input resize="none" maxlength="30" show-word-limit type="textarea"
                    placeholder="建议填写图文咨询的简短介绍.(例如：医生接诊后24小时内无限次交流)" v-model.trim="information2.describe">
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col>
                <el-form-item label="开启协同: " prop="synergyDisabled">
                  <el-radio-group v-model="information2.synergyDisabled">
                    <el-radio :label="false">是</el-radio>
                    <el-radio :label="true">否</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="14">
                <el-form-item v-if="!information2.synergyDisabled" label="图文咨询费: " prop="synergyTextConsultFee">
                  <el-input type="text" v-model.trim="information2.synergyTextConsultFee" placeholder="请输入咨询费">
                    <template slot="append">元</template>
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="14">
                <el-form-item v-if="!information2.synergyDisabled" label="视频咨询费: " prop="synergyVideoConsultFee">
                  <el-input type="text" v-model.trim="information2.synergyVideoConsultFee" placeholder="请输入咨询费">
                    <template slot="append">元</template>
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="14">
                <el-form-item v-if="!information2.synergyDisabled" label="服务时长: ">
                  <el-input type="text" v-model.trim="information2.synergyServiceTime" placeholder="请输入服务时长"
                    onkeyup="value = value.replace(/[^\d]/g,'')" maxlength="2">
                    <template slot="append">小时</template>
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col>
                <el-form-item v-if="!information2.synergyDisabled" label="咨询简介: " prop="synergyDescribe">
                  <el-input resize="none" maxlength="30" show-word-limit type="textarea"
                    placeholder="建议填写图文咨询的简短介绍.(例如：医生接诊后24小时内无限次交流)" v-model.trim="information2.synergyDescribe">
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <span class="dialog-footer">
              <el-button class="dialog-btn" size="small" type="primary" @click="submiAddCare6('cnForm')">保存</el-button>
            </span>
          </el-form>
        </template>
        <template v-else>
          <el-form @submit.native.prevent :model="information2" label-width="100px" :rules="rules1">
            <el-form-item v-if="information2.disabled == 0" label="图文咨询: " prop="consultFee">
              <span style="font-size:14px;font-weight:bolder;color: #1A7BFC;width:100px;text-align:right">
                是
              </span>
            </el-form-item>
            <el-form-item v-if="information2.freeClinicsDisabled == false" label="义诊: " prop="consultFee">
              <span style="font-size:14px;font-weight:bolder;color: #1A7BFC;width:100px;text-align:right">
                是
              </span>
            </el-form-item>

            <el-form-item v-if="information2.disabled == 0" label="咨询费: " prop="consultFee">
              <span>{{ information2.consultFee }}</span>
            </el-form-item>

            <el-form-item v-if="information2.disabled == 0" label="服务时长: " prop="serviceTime">
              <span>{{ information2.serviceTime }}</span>
            </el-form-item>

            <el-form-item v-if="information2.disabled == 0" label="咨询简介: " prop="describe">
              <span>{{ information2.describe }}</span>
            </el-form-item>

            <el-form-item v-if="!information2.synergyDisabled" label="开启协同: " prop="consultFee">
              <span style="font-size:14px;font-weight:bolder;color: #1A7BFC;width:100px;text-align:right">
                {{!information2.synergyDisabled?'是':'否'}}
              </span>
            </el-form-item>

            <el-form-item v-if="!information2.synergyDisabled" label="图文咨询费: " prop="synergyTextConsultFee">
              <span>{{ information2.synergyTextConsultFee }}</span>
            </el-form-item>

            <el-form-item v-if="!information2.synergyDisabled" label="视频咨询费: " prop="synergyVideoConsultFee">
              <span>{{ information2.synergyVideoConsultFee }}</span>
            </el-form-item>

            <el-form-item v-if="!information2.synergyDisabled" label="服务时长: ">
              <span>{{ information2.synergyServiceTime }}</span>
            </el-form-item>

            <el-form-item v-if="!information2.synergyDisabled" label="咨询简介: " prop="synergyDescribe">
              <span>{{ information2.synergyDescribe }}</span>
            </el-form-item>

          </el-form>
          <div v-if='information2.disabled != 0 && information2.synergyDisabled' class="no-div">
            <img src="@/assets/images/nodata.png" alt="" />
            <p>暂未开通问诊</p>
          </div>
          <span class="dialog-footer" v-if="!isEdit2">
            <el-button class="dialog-btn" size="small" type="primary" @click="isEdit2 = true">去编辑</el-button>
          </span>
        </template>
      </div>
    </el-main>
  </el-container>
</template>

<script>
import {
  api_hospital,
  api_department,
  api_doctor_title,
  setAsStar,
  setHospitalAsStar,
  inquiry_config_detailByRefId,
  inquiry_config,
  inquiry_config_post,
  getListByHospitalId,
} from "./api/medicalinfo";
import {
  getDoctor,
  updetaDoctor,
  api_doctor_search,
  renmoveDoctor,
  offDisable,
  offEnable,
} from "@/api/docinfo";
import axios from "axios";
import local from "@/utils/local.js";

import {
  api_doctor_team,
  associateList,
  distribute,
} from "@/api/Patientmanagement.js";
import {
  hospital,
  openeDpartment,
  treeList,
  doctorTeam,
} from "@/api/doctorTeam.js";
import {
  submitCertificate,
  getPlatformList,
  getPlatformDepartmentList,
  getPlatformOpenDepartmentList,
  addDoctorPlatform,
  deleteDoctorPlatform,
  getListByDoctorId,
  getDoctorNursingDetail,
  doctorNurseCreate,
  checkIdCardNumber,
  getStrategicDiseaseAndWechat,
  doctor_title,
} from "./api";
export default {
  components: {},
  props: {},
  data() {
    // 手机号验证
    var validatorPhone = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("手机号不能为空"));
      } else if (!/^1\d{10}$/.test(value)) {
        callback(new Error("手机号格式错误"));
      } else {
        callback();
      }
    };
    // 身份证验证
    var validatorCard = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("身份证号不能为空"));
      } else if (
        !/^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/.test(
          value
        )
      ) {
        callback(new Error("身份证号格式错误"));
      } else {
        callback();
      }
    };
    return {
      certificateStatus: "",
      activeName1: 1,
      crolBtn: false,
      isEdit1: false,
      isEdit2: false,
      isEdit3: false,
      loadingNew: false,
      diseaseList: [],
      userPlatForm: local.get("userPlatForm"), //平台：platForm 机构：organization local.get('userPlatForm')
      SetKesDept: {
        value: "id",
        label: "name",
        children: "children",
        emitPath: false,
      }, //设置联级选择器绑定的值
      SetKesDeptNew: {
        value: "id",
        label: "name",
        children: "children",
        emitPath: false,
        multiple: true,
      }, //设置联级选择器绑定的值
      setKesDept: {
        value: "id",
        label: "name",
        children: "children",
        disabled: "value",
        emitPath: false,
      },
      information1: {
        realName: "", //姓名
        mobile: "", //手机号码
        idCard: "", //证件 号码
        // gender: '', //性别 1男2女0未知
        // birthday: '', //出生日期
        avatar: "", //医生照片
        photoUrlCopy: "", //用来展示图片
        note: "", //介绍
        departmentId: "", //科室ID
        departmentName: "",
        doctorType: "", //医护类型1.医生,2.护士,3.医技,4.药师6医辅
        hospitalId: "", //医院ID
        hospitalName: "",
        professional: "", //专业擅长
        titleId: "", //职称ID
        titleName: "",
        serviceScopeKm: "", //上门服务km
        provideNursingService: true,
        sharingPicUrl: "",
        serviceWishes: "",
        diseaseServingDTOList: [],
        hospitalList: [],
        platformAssist: "0",
        hospitalListNew: [],
        userId: "",
      },
      doctorCertificateSubmitDTO: {
        idCard: {
          back: "",
          front: "",
          watermarkBack: "",
          watermarkFront: "",
        },
        other: {
          watermarkFiles: "",
          files: [],
        },
        practice: {
          watermarkFiles: "",
          files: [],
          number: "",
          obtainDate: "",
        },
        qualification: {
          watermarkFiles: "",
          files: [],
          obtainDate: "",
          number: "",
        },
        title: {
          watermarkFiles: "",
          files: [],
          obtainDate: "",
          number: "",
        },
        nameBadge: {
          watermarkFiles: "",
          files: [],
          obtainDate: "",
          number: "",
        },
      },
      doctorTeam: {
        type: "0",
        id: "",
        doctorTeamName: "",
        name: "",
        departmentId: "",
        departmentName: "",
        platformId: "",
        platformName: "",
        caseMgrGroupId: "",
        caseMgrGroupName: "",
      },
      newSelectTteam: "",
      upavater: "", //需要上传的图片路径
      VUE_APP_BASE_URL: "",
      VUE_APP_BASE_URL1: "",
      isMdt: false,
      doctorTitleList: [],
      joinedTeamList: [],
      doctorTeamList: [], //其他团队
      platformOptions: [], //归属平台
      departmentList: [], //归属科室
      departmentList1: [], //归属科室
      caseMgrGroupList: [], //个案组列表
      hospitalList: [],
      information2: {
        disabled: true,
        consultFee: "",
        serviceTime: "",
        describe: "",
        id: "",
        freeClinicsDisabled: true,
        synergyDisabled: true,
        synergyTextConsultFee: "",
        synergyVideoConsultFee: "",
        synergyServiceTime: "",
        synergyDescribe: "",
      },
      rules1: {
        disabled: [
          {
            required: true,
            message: "请选择是否开启",
            trigger: "blur",
          },
        ],
        consultFee: [
          {
            required: true,
            // validate:validatorConsultFee,
            trigger: "blur",
            pattern: /^\d+(\.\d+)?$/,
            message: "请按要求输入咨询费",
          },
        ],
        serviceTime: [
          {
            required: true,
            pattern: /^[1-9]\d*$/,
            // validate:validatorServiceTime,
            message: "请按要求输入服务时长",
            trigger: "blur",
          },
        ],
        synergyDisabled: [
          {
            required: true,
            message: "请选择协同",
            trigger: "change",
          },
        ],
        synergyTextConsultFee: [
          {
            required: true,
            // validate:validatorConsultFee,
            trigger: "blur",
            pattern: /^\d+(\.\d+)?$/,
            message: "请按要求输入图文咨询费",
          },
        ],
        synergyVideoConsultFee: [
          {
            required: true,
            // validate:validatorConsultFee,
            trigger: "blur",
            pattern: /^\d+(\.\d+)?$/,
            message: "请按要求输入视频咨询费",
          },
        ],
        synergyServiceTime: [
          {
            required: true,
            pattern: /^[1-9]\d*$/,
            // validate:validatorServiceTime,
            message: "请按要求输入服务时长",
            trigger: "blur",
          },
        ],
      },
      rules: {
        // hospitalId: [{

        // 	message: "请选择线下医院",
        // 	trigger: "change"
        // }, ],

        // departmentId: [{

        // 	message: "请选择线下科室",
        // 	trigger: "change"
        // }, ],
        realName: [
          {
            required: true,
            message: "请输入医生名称",
            trigger: "blur",
          },
          {
            min: 2,
            max: 5,
            message: "长度在 2 到 5 个字符",
            trigger: "blur",
          },
        ],
        mobile: [
          {
            required: true,
            validator: validatorPhone,
            trigger: "blur",
          },
        ],
        idCard: [
          {
            required: true,
            validator: validatorCard,
            trigger: "blur",
          },
        ],

        doctorType: [
          {
            required: true,
            message: "请选择医护类型",
            trigger: "change",
          },
        ],
        titleId: [
          {
            required: true,
            message: "请选择职称",
            trigger: "change",
          },
        ],
        professional: [
          {
            required: true,
            message: "请输入专业擅长",
            trigger: "blur",
          },
          {
            min: 1,
            max: 500,
            message: "长度在 1 到 500 个字符",
            trigger: "blur",
          },
        ],
        note: [
          {
            required: true,
            message: "请输入医生介绍",
            trigger: "blur",
          },
          {
            min: 1,
            max: 500,
            message: "长度在 1 到 500 个字符",
            trigger: "blur",
          },
        ],
        serviceScopeKm: [
          {
            required: true,
            message: "请输入服务范围",
            trigger: "blur",
          },
        ],
        provideNursingService: [
          {
            required: true,
            message: "请选择是否提供上门服务",
            trigger: "blur",
          },
        ],
      },
      flagId: "",
      wxUploadList: [],
      btnFlag: false,
      hospitalListBackup: [],
    };
  },
  watch: {
    "information1.diseaseServingDTOList": {
      handler: function (newVal, oldVal) {
        // alert('898998')
        this.wxUploadList = this.information1.diseaseServingDTOList.map(
          (item) => {
            return { appId: item.appId, mediaId: item.mediaId };
          }
        );
      },
    },
  },
  computed: {},
  methods: {
    diseaseChange() {
      this.information1.sharingPicUrl = "";
    },
    handleSharingPicUrlResponse(response) {
      if (response.code == 0) {
        for (
          let index = 0;
          index < response.data.wechatMediaList.length;
          index++
        ) {
          for (
            var j = 0;
            j < this.information1.diseaseServingDTOList.length;
            j++
          ) {
            if (
              response.data.wechatMediaList[index].appId ==
              this.information1.diseaseServingDTOList[j].appId
            ) {
              this.information1.diseaseServingDTOList[j].mediaId =
                response.data.wechatMediaList[index].mediaId;
            }
          }
        }
        return (this.information1.sharingPicUrl = `${process.env.VUE_APP_OSS_URL}${response.data.ossUrl}`);
      }
    },
    closeaddCare4() {
      this.upavater = ""; //医生照片
      (this.information1.note = ""), //介绍
        (this.information1.departmentId = ""); //科室ID
      this.information1.professional = ""; //专业擅长
      // this.information1.hospitalId = ""; //医院ID
      // this.information1.hospitalName = '';
      this.information1.serviceScopeKm = ""; //上门服务km
      this.information1.provideNursingService = true;
    },
    handleTabClick(tab) {
      if (tab != 1 && !this.information1.idCardNumber.trim()) {
        return this.$message.info("请填写身份信息");
      }
      this.activeName1 = tab;
      if (tab === 3) {
        inquiry_config_detailByRefId({
          refId: this.information1.id ? this.information1.id : this.$route.query.id,
        }).then((res) => {
          console.log(123123, res);
          if (!res.data.id) {
            inquiry_config_post({
              belong: 1,
              refId: this.$route.query.id,
              disabled: true,
              consultFee: 0,
              serviceTime: 0,
              describe: "",
              freeClinicsDisabled: true,
            }).then(() => {
              inquiry_config_detailByRefId({
                refId: data ? data : this.$route.query.id,
              }).then((res) => {
                console.log(res, "daada");

                this.information2.id = res.data.id;
                this.information2.disabled = res.data.disabled;
                this.information2.consultFee = res.data.consultFee
                  ? res.data.consultFee / 100
                  : "";
                this.information2.serviceTime = res.data.serviceTime || "";
                this.information2.describe = res.data.describe;

                (this.information2.synergyDisabled = res.data.synergyDisabled),
                  (this.information2.synergyTextConsultFee =
                    res.data.synergyTextConsultFee != null
                      ? res.data.synergyTextConsultFee / 100
                      : "");
                this.information2.synergyVideoConsultFee =
                  res.data.synergyVideoConsultFee != null
                    ? res.data.synergyVideoConsultFee / 100
                    : "";

                this.information2.synergyServiceTime = res.data
                  .synergyServiceTime
                  ? res.data.synergyServiceTime
                  : "";
                this.information2.synergyDescribe = res.data.synergyDescribe;
              });
            });
            return;
          }
          this.information2.id = res.data.id;
          this.information2.disabled = res.data.disabled;
          this.information2.consultFee = res.data.consultFee
            ? res.data.consultFee / 100
            : "";
          this.information2.serviceTime = res.data.serviceTime || "";
          this.information2.describe = res.data.describe;

          (this.information2.synergyDisabled = res.data.synergyDisabled),
            (this.information2.synergyTextConsultFee =
              res.data.synergyTextConsultFee != null
                ? res.data.synergyTextConsultFee / 100
                : "");
          this.information2.synergyVideoConsultFee =
            res.data.synergyVideoConsultFee != null
              ? res.data.synergyVideoConsultFee / 100
              : "";

          this.information2.synergyServiceTime = res.data.synergyServiceTime
            ? res.data.synergyServiceTime
            : "";
          this.information2.synergyDescribe = res.data.synergyDescribe;
        });
      }
    },
    submiAddCare5() {
      if (!this.doctorCertificateSubmitDTO.idCard.back) {
        return this.$message.error("请上传国徽面");
      }
      if (!this.doctorCertificateSubmitDTO.idCard.front) {
        return this.$message.error("请上传头像面");
      }
      // if(this.information1.doctorType==1||this.information1.doctorType==2||this.information1.doctorType==4){
      if (
        !this.doctorCertificateSubmitDTO.practice.files.length ||
        this.doctorCertificateSubmitDTO.practice.files.length < 2
      ) {
        return this.$message.error("请按要求上传执业证");
      }
      if (!this.doctorCertificateSubmitDTO.practice.obtainDate) {
        return this.$message.error("请选择发证日期");
      }
      if (
        !this.doctorCertificateSubmitDTO.practice.number ||
        !/^[0-9a-zA-Z]*$/g.test(this.doctorCertificateSubmitDTO.practice.number)
      ) {
        return this.$message.error("请输入数字、字母或数字字母组合证书编号");
      }
      if (
        !this.doctorCertificateSubmitDTO.qualification.files.length ||
        this.doctorCertificateSubmitDTO.qualification.files.length < 2
      ) {
        return this.$message.error("请按要求上传资格证");
      }
      if (!this.doctorCertificateSubmitDTO.qualification.obtainDate) {
        return this.$message.error("请选择发证日期");
      }
      if (
        !this.doctorCertificateSubmitDTO.qualification.number ||
        !/^[0-9a-zA-Z]*$/g.test(
          this.doctorCertificateSubmitDTO.qualification.number
        )
      ) {
        return this.$message.error("请输入数字、字母或数字字母组合证书编号");
      }
      if (this.information1.doctorType !== 6 && !this.doctorCertificateSubmitDTO.nameBadge.files.length) {
        return this.$message.error("请按要求上传胸牌");
      }
      // }
      var doctorCertificateSubmit = {
        idCard: this.doctorCertificateSubmitDTO.idCard,
        other: {
          watermarkFiles: this.doctorCertificateSubmitDTO.other.watermarkFiles,
          files: this.doctorCertificateSubmitDTO.other.files || [],
        },
        practice: {
          watermarkFiles:
            this.doctorCertificateSubmitDTO.practice.watermarkFiles,
          files: this.doctorCertificateSubmitDTO.practice.files || [],
        },
        qualification: {
          watermarkFiles:
            this.doctorCertificateSubmitDTO.qualification.watermarkFiles,
          files: this.doctorCertificateSubmitDTO.qualification.files || [],
        },
        title: {
          watermarkFiles: this.doctorCertificateSubmitDTO.title.watermarkFiles,
          files: this.doctorCertificateSubmitDTO.title.files || [],
        },
        nameBadge: {
          watermarkFiles:
            this.doctorCertificateSubmitDTO.nameBadge.watermarkFiles,
          files: this.doctorCertificateSubmitDTO.nameBadge.files || [],
        },
      };
      var img = {
        idCard: {
          back: "",
          front: "",
          watermarkFront: "",
          watermarkBack: "",
        },
        other: {
          files: [],
          watermarkFiles: "",
        },
        practice: {
          files: [],
          watermarkFiles: "",
          number: this.doctorCertificateSubmitDTO.practice.number,
          obtainDate: this.doctorCertificateSubmitDTO.practice.obtainDate
            ? this.doctorCertificateSubmitDTO.practice.obtainDate + " 00:00:00"
            : "",
        },
        qualification: {
          files: [],
          watermarkFiles: "",
          number: this.doctorCertificateSubmitDTO.qualification.number,
          obtainDate: this.doctorCertificateSubmitDTO.qualification.obtainDate
            ? this.doctorCertificateSubmitDTO.qualification.obtainDate +
              " 00:00:00"
            : "",
        },
        title: {
          watermarkFiles: "",
          files: [],
        },
        nameBadge: {
          watermarkFiles: "",
          files: [],
        },
      };
      Object.keys(img).forEach((item) => {
        if (item == "idCard") {
          Object.keys(doctorCertificateSubmit[item]).forEach((sub) => {
            img[item][sub] = doctorCertificateSubmit[item][sub].substring(
              process.env.VUE_APP_OSS_URL.length
            );
          });
        } else {
          // debugger
          img[item].files =
            doctorCertificateSubmit[item].files.length > 0
              ? doctorCertificateSubmit[item].files
                  .map((items) =>
                    items.substring(process.env.VUE_APP_OSS_URL.length)
                  )
                  .join(",")
              : "";
          img[item].watermarkFiles =
            doctorCertificateSubmit[item].watermarkFiles;
        }
      });
      submitCertificate({
        doctorId: this.information1.id,
        ...img,
      }).then((res) => {
        this.$message.success(`提交成功`);
        // this.info();
        this.getdetail(this.information1.id);
        this.isEdit3 = false;
      });
    },
    disabledChanged(e) {
      console.log(e);
      if (!e && this.certificateStatus != 3) {
        this.information2.disabled = true;
        this.$message.info("医生审核暂未通过，不可开通图文咨询");
        // this.$alert('医生审核暂未通过，不可开通图文咨询', '', {
        //   confirmButtonText: '确定',
        //   callback: action => {

        //   }
        // });
      }
      if (e) {
        this.information2.freeClinicsDisabled = true;
      }
    },
    /**
     *
     * 关闭新增医护弹回调
     */
    closeaddCare5() {
      this.doctorCertificateSubmitDTO.idCard = {
        back: "",
        front: "",
        watermarkBack: "",
        watermarkFront: "",
      };
      (this.doctorCertificateSubmitDTO.other = {
        files: [],
        fileList: [],
        watermarkFiles: "",
      }),
        (this.doctorCertificateSubmitDTO.practice = {
          files: [],
          fileList: [],
          number: "",
          obtainDate: "",
          watermarkFiles: "",
        }),
        (this.doctorCertificateSubmitDTO.qualification = {
          files: [],
          fileList: [],
          obtainDate: "",
          number: "",
          watermarkFiles: "",
        });
      this.doctorCertificateSubmitDTO.title = {
        files: [],
        fileList: [],
        obtainDate: "",
        number: "",
        watermarkFiles: "",
      };
      this.doctorCertificateSubmitDTO.nameBadge = {
        files: [],
        fileList: [],
        obtainDate: "",
        number: "",
        watermarkFiles: "",
      };
    },
    /**
     * @description:
     * @param {*}
     * @return {*}
     */
    inputNumber(e) {
      this.$nextTick(() => {
        this.information1.serviceScopeKm = e
          .replace(/[^\d.]/g, "")
          .replace(/\.{2,}/g, ".")
          .replace(".", "$#$")
          .replace(/\./g, "")
          .replace("$#$", ".")
          .replace(/^(\-)*(\d+)\.(\d).*$/, "$1$2.$3")
          .replace(/^\./g, "");
      });
    },
    submiAddCare6(ref) {
      this.$refs[ref].validate(async (valid) => {
        if (valid) {
          if (!this.information2.disabled) {
            var consultFee = Number(this.information2.consultFee);
            var serviceTime = Number(this.information2.serviceTime);
            if (consultFee <= 0 || consultFee > 9999.99) {
              return this.$message.error("请按要求填写咨询费");
            }
            if (serviceTime <= 0 || serviceTime > 24) {
              return this.$message.error("请按要求填写服务时长");
            }
            if (String(this.information2.serviceTime).split(".").length) {
              if (
                String(this.information2.serviceTime).split(".").length == 2 &&
                String(this.information2.serviceTime).split(".")[1].length > 1
              ) {
                return this.$message.error("请按要求填写服务时长");
              }
            }
            if (String(this.information2.consultFee).split(".").length) {
              if (
                String(this.information2.consultFee).split(".").length == 2 &&
                String(this.information2.consultFee).split(".")[1].length > 2
              ) {
                return this.$message.error("请按要求填写咨询费");
              }
            }
          }
          console.log(
            this.information2.synergyDisabled,
            "this.information2.synergyDisabled"
          );
          if (!this.information2.synergyDisabled) {
            var synergyTextConsultFee = Number(
              this.information2.synergyTextConsultFee
            ); //图文咨询费
            var synergyVideoConsultFee = Number(
              this.information2.synergyVideoConsultFee
            ); //视频咨询费
            var synergyServiceTime = Number(
              this.information2.synergyServiceTime
            );
            console.log(isNaN(synergyTextConsultFee), "synergyTextConsultFee");
            if (
              synergyTextConsultFee < 0 ||
              synergyTextConsultFee > 9999.99 ||
              isNaN(synergyTextConsultFee)
            ) {
              return this.$message.error("请按要求填写图文咨询费");
            }
            if (
              synergyVideoConsultFee < 0 ||
              synergyVideoConsultFee > 9999.99 ||
              isNaN(synergyVideoConsultFee)
            ) {
              return this.$message.error("请按要求填写视频咨询费");
            }
            if (synergyServiceTime <= 0 || synergyServiceTime > 24) {
              return this.$message.error("请按要求填写服务时长");
            }
            if (
              String(this.information2.synergyServiceTime).split(".").length
            ) {
              if (
                String(this.information2.synergyServiceTime).split(".")
                  .length == 2 &&
                String(this.information2.synergyServiceTime).split(".")[1]
                  .length > 1
              ) {
                return this.$message.error("请按要求填写服务时长");
              }
            }
            if (
              String(this.information2.synergyTextConsultFee).split(".").length
            ) {
              if (
                String(this.information2.synergyTextConsultFee).split(".")
                  .length == 2 &&
                String(this.information2.synergyTextConsultFee).split(".")[1]
                  .length > 2
              ) {
                return this.$message.error("请按要求填写图文咨询费");
              }
            }
            if (
              String(this.information2.synergyVideoConsultFee).split(".").length
            ) {
              if (
                String(this.information2.synergyVideoConsultFee).split(".")
                  .length == 2 &&
                String(this.information2.synergyVideoConsultFee).split(".")[1]
                  .length > 2
              ) {
                return this.$message.error("请按要求填写视频咨询费");
              }
            }
          }
          inquiry_config({
            refId: this.information1.id,
            belong: 1,
            disabled: this.information2.disabled,
            consultFee: consultFee * 100,
            serviceTime: serviceTime,
            describe: this.information2.describe,
            id: this.information2.id,
            freeClinicsDisabled: this.information2.freeClinicsDisabled,
            synergyDisabled: this.information2.synergyDisabled,
            synergyTextConsultFee:
              this.information2.synergyTextConsultFee * 100,
            synergyVideoConsultFee:
              this.information2.synergyVideoConsultFee * 100,
            synergyServiceTime:
              this.information2.synergyServiceTime == ""
                ? 0
                : this.information2.synergyServiceTime,
            synergyDescribe: this.information2.synergyDescribe,
          }).then((res) => {
            this.isEdit2 = false;
            this.getdetail();
          });
        } else {
        }
      });
    },
    submiAddCare4(ref) {
      console.log(123123);
      this.$refs[ref].validate(async (valid) => {
        if (valid) {
          if (!this.upavater) return this.$message.error("请上传医生照片");
          if (
            this.information1.diseaseServingDTOList.length &&
            !this.information1.sharingPicUrl
          ) {
            return this.$message.error("请上传公众号配图");
          }
          let flagEdit = false;
          if (
            this.information1.doctorType == 6 &&
            this.information1.platformAssist == 1
          ) {
            // if(JSON.stringify(this.hospitalListBackup) != JSON.stringify(this.information1.hospitalList)){
            //   flagEdit = false
            // }else{
            //   flagEdit = true
            // }

            // for(var i=0;i<this.information1.hospitalList.length;i++){
            //   for(var j=0;j<this.hospitalListBackup.length;j++){
            //     if(this.information1.hospitalList[i].hospitalId == this.hospitalListBackup[j].hospitalId){
            //       flagEdit = true
            //     }
            //   }
            // }
            let hospitalIdList = [];
            let newHospitalIdList = [];
            this.information1.hospitalList.forEach((item) => {
              hospitalIdList.push(item.hospitalId);
            });
            this.hospitalListBackup.forEach((item) => {
              newHospitalIdList.push(item.hospitalId);
            });
            if (
              JSON.stringify(hospitalIdList) !=
              JSON.stringify(newHospitalIdList)
            ) {
              flagEdit = false;
            } else {
              flagEdit = true;
            }
          }

          console.log(flagEdit, "flagEdit");
          console.log(
            !this.btnFlag,
            this.information1.platformAssist == 1,
            !flagEdit,
            "条件"
          );

          if (
            !this.btnFlag &&
            this.information1.platformAssist == 1 &&
            !flagEdit
          ) {
            this.$message.error("请点击确认，刷新归属团队");
            return false;
          }

          let flag = false;
          if (this.information1.hospitalList.length > 0) {
            console.log(
              this.information1.hospitalList,
              "this.information1.hospitalList"
            );
            this.information1.hospitalList.forEach((item, index) => {
              if (item.hospitalId == null || item.hospitalName == null) {
                console.log("走否");
                flag = true;
              }
              if (
                item.openDepartmentIdlist &&
                item.openDepartmentIdlist.length > 0
              ) {
                console.log("走是");
                item.openDepartmentIdlist.forEach((el, i) => {
                  if (
                    el.openDepartmentId == null ||
                    el.openDepartmentName == null
                  ) {
                    flag = true;
                  }
                });
              }
            });
          }
          if (flag && this.information1.doctorType == 6) {
            this.$message.error("请选择线下机构或者线下科室");
            return false;
          }
          updetaDoctor({
            departmentId: this.information1.departmentId,
            // disabled: this.information1.disabled,
            // idCardType: this.information1.idCardType,
            doctorType: this.information1.doctortype,
            sharingPicUrl: this.information1.diseaseServingDTOList.length
              ? this.information1.sharingPicUrl.substring(
                  process.env.VUE_APP_OSS_URL.length
                )
              : "",
            serviceWishes: this.information1.serviceWishes.trim()
              ? this.information1.serviceWishes
              : "",
            diseaseServingDTOList: this.information1.diseaseServingDTOList,
            hospitalId: this.information1.hospitalId,
            id: this.information1.id,
            idCardNumber: this.information1.idCard,
            introduction: this.information1.note,
            // introduction: this.information1.introduction,
            name: this.information1.realName,
            phone: this.information1.phone,
            professional: this.information1.professional,
            provideNursingService: this.information1.provideNursingService,
            serviceScopeKm: this.information1.serviceScopeKm,
            titleId: this.information1.titleId,
            masterPhotoUrl: this.upavater.substring(
              process.env.VUE_APP_OSS_URL.length
            ),
            photoUrl: this.upavater.substring(
              process.env.VUE_APP_OSS_URL.length
            ),
            id: this.information1.id,
            platformAssist: this.information1.platformAssist * 1,
            hospitalList: this.information1.hospitalList,
          }).then((res) => {
            this.$message.success("操作成功");
            // this.isEdit1 = false;
            // this.info();
            this.getdetail(this.information1.id, "save");
          });
        } else {
        }
      });
    },
    submiAddCare3() {
      if (!this.doctorCertificateSubmitDTO.idCard.back) {
        return this.$message.error("请上传国徽面");
      }
      if (!this.doctorCertificateSubmitDTO.idCard.front) {
        return this.$message.error("请上传头像面");
      }
      if (
        !this.doctorCertificateSubmitDTO.qualification.files.length ||
        this.doctorCertificateSubmitDTO.qualification.files.length < 2
      ) {
        return this.$message.error("请按要求上传资格证");
      }
      if (!this.doctorCertificateSubmitDTO.qualification.obtainDate) {
        return this.$message.error("请选择发证日期");
      }
      if (
        !this.doctorCertificateSubmitDTO.qualification.number ||
        !/^[0-9a-zA-Z]*$/g.test(
          this.doctorCertificateSubmitDTO.qualification.number
        )
      ) {
        return this.$message.error("请输入数字、字母或数字字母组合证书编号");
      }
      if (
        !this.doctorCertificateSubmitDTO.practice.files.length ||
        this.doctorCertificateSubmitDTO.practice.files.length < 2
      ) {
        return this.$message.error("请按要求上传执业证");
      }
      if (!this.doctorCertificateSubmitDTO.practice.obtainDate) {
        return this.$message.error("请选择发证日期");
      }
      if (
        !this.doctorCertificateSubmitDTO.practice.number ||
        !/^[0-9a-zA-Z]*$/g.test(this.doctorCertificateSubmitDTO.practice.number)
      ) {
        return this.$message.error("请输入数字、字母或数字字母组合证书编号");
      }
      if (!this.doctorCertificateSubmitDTO.nameBadge.files.length) {
        return this.$message.error("请按要求上传胸牌");
      }

      this.submiAddCare();
    },
    // doctorNurseCreate
    /**
     * 提交新增医护提交
     *
     */
    submiAddCare(ref) {
      if (!this.upavater) return this.$message.error("请上传医生照片");
      this.loadingNew = true;
      this.accountobj.mobile = this.information1.mobile;
      this.infoobj.avatar = this.upavater.substring(
        process.env.VUE_APP_OSS_URL.length
      );
      // let information = {...this.information1};
      if (this.userPlatForm == "organization") {
        this.doctorTeam.hospitalId = local.get("hospitalId");
      }
      this.information1.hospitalId
        ? this.information1.hospitalId
        : (this.information1.hospitalId = local.get("hospitalId"));
      this.infoobj.idCard = this.information1.idCard;
      this.infoobj.mobile = this.information1.mobile;
      this.infoobj.note = this.information1.note;
      this.infoobj.realName = this.information1.realName;
      this.doctorobj.departmentId = this.information1.departmentId;
      this.doctorobj.doctorType = this.information1.doctorType;
      this.doctorobj.hospitalId = this.information1.hospitalId;
      this.doctorobj.professional = this.information1.professional;
      this.doctorobj.titleId = this.information1.titleId;
      this.doctorobj.serviceScopeKm = this.information1.serviceScopeKm;
      this.doctorobj.provideNursingService =
        this.information1.provideNursingService;
      // return

      var doctorCertificateSubmit = {
        idCard: {
          back: this.doctorCertificateSubmitDTO.idCard.back,
          front: this.doctorCertificateSubmitDTO.idCard.front,
          watermarkBack: this.doctorCertificateSubmitDTO.idCard.watermarkBack,
          watermarkFront: this.doctorCertificateSubmitDTO.idCard.watermarkFront,
        },
        other: {
          watermarkFiles: this.doctorCertificateSubmitDTO.other.watermarkFiles,
          files: this.doctorCertificateSubmitDTO.other.files || [],
        },
        practice: {
          watermarkFiles:
            this.doctorCertificateSubmitDTO.practice.watermarkFiles,
          files: this.doctorCertificateSubmitDTO.practice.files || [],
        },
        qualification: {
          watermarkFiles:
            this.doctorCertificateSubmitDTO.qualification.watermarkFiles,
          files: this.doctorCertificateSubmitDTO.qualification.files || [],
        },
        title: {
          watermarkFiles: this.doctorCertificateSubmitDTO.title.watermarkFiles,
          files: this.doctorCertificateSubmitDTO.title.files || [],
        },
        nameBadge: {
          watermarkFiles:
            this.doctorCertificateSubmitDTO.nameBadge.watermarkFiles,
          files: this.doctorCertificateSubmitDTO.nameBadge.files || [],
        },
      };
      var img = {
        idCard: {
          back: "",
          front: "",
          watermarkFront: "",
          watermarkBack: "",
        },
        other: {
          files: [],
          watermarkFiles: "",
        },
        practice: {
          files: [],
          watermarkFiles: "",
          number: this.doctorCertificateSubmitDTO.practice.number,
          obtainDate: this.doctorCertificateSubmitDTO.practice.obtainDate
            ? this.doctorCertificateSubmitDTO.practice.obtainDate + " 00:00:00"
            : "",
        },
        qualification: {
          files: [],
          watermarkFiles: "",
          number: this.doctorCertificateSubmitDTO.qualification.number,
          obtainDate: this.doctorCertificateSubmitDTO.qualification.obtainDate
            ? this.doctorCertificateSubmitDTO.qualification.obtainDate +
              " 00:00:00"
            : "",
        },
        title: {
          watermarkFiles: "",
          files: [],
        },
        nameBadge: {
          watermarkFiles: "",
          files: [],
        },
      };
      Object.keys(img).forEach((item) => {
        if (item == "idCard") {
          Object.keys(doctorCertificateSubmit[item]).forEach((sub) => {
            img[item][sub] = doctorCertificateSubmit[item][sub].substring(
              process.env.VUE_APP_OSS_URL.length
            );
          });
        } else {
          img[item].watermarkFiles =
            doctorCertificateSubmit[item].watermarkFiles;
          // debugger
          img[item].files =
            doctorCertificateSubmit[item].files.length > 0
              ? doctorCertificateSubmit[item].files
                  .map((items) =>
                    items.substring(process.env.VUE_APP_OSS_URL.length)
                  )
                  .join(",")
              : "";
        }
      });
      var basicToken =
        "Basic ZHNpY20tYXBwLWRvY3Rvcjpkc2ljbS1hcHAtZG9jdG9yLXB3Jl4kKiZA";
      // 创建药师的token不一样 取值和此客户端相同的basictoken
      // if (this.information1.doctorType === 4) {
      // 	basicToken = "Basic ZHNpY20td2ViLW1hbmFnZXI6ZHNpY20td2ViLW1hbmFnZXItcHcjJCMlQA==";
      // }
      axios({
        method: "post", // post、get、put....
        url: "/admin/user/create/doctor", // 请求的路径
        headers: {
          Authorization: basicToken,
        },
        data: {
          createUserId: local.get("userid"),
          account: this.accountobj,
          doctorInfo: this.information1,
          info: this.infoobj,
          doctorCertificateSubmitDTO: img,
          isMdt: this.information1.doctorType == 1 ? this.isMdt : null,
          doctorTeam: this.newSelectTteam ? this.doctorTeam : null,
        },
      })
        .then((res) => {
          if (res.data.code === 0) {
            this.loadingNew = false;
            this.$message({
              message: "当前医护信息已提交成功！请耐心等待审核~",
              type: "success",
            });
            this.$router.go(-1);
            this.information1 = this.$options.data().information1;
          } else {
            this.loadingNew = false;
            this.$message({
              message: res.data.message,
              type: "error",
            });
          }
        })
        .catch((err) => {
          this.loadingNew = false;
        });
    },
    handleMessageResponse2(response) {
      if (response.code == 0) {
        return (this.upavater = `${process.env.VUE_APP_OSS_URL}${response.data}`);
      }
    },
    handleMessageResponse3(res) {
      if (res.code !== 0) {
        return;
      }
      this.doctorCertificateSubmitDTO.idCard.watermarkBack = `${process.env.VUE_APP_OSS_URL}${res.data.watermarkUrl}`;
      return (this.doctorCertificateSubmitDTO.idCard.back = `${process.env.VUE_APP_OSS_URL}${res.data.sourceUrl}`);
    },
    handleMessage3beforeRemove(file, fileList, index) {
      // if(this.doctorCertificateSubmitDTO.idCard.watermarkFiles.split(',').length - 1 < index){
      //  return;
      // }
      // let str = this.doctorCertificateSubmitDTO.idCard.watermarkFront.split(',').splice(index,1).join(',');
      this.doctorCertificateSubmitDTO.idCard.watermarkBack = "";
    },
    handleMessageResponse4(res) {
      if (res.code !== 0) {
        return;
      }
      this.doctorCertificateSubmitDTO.idCard.watermarkFront = `${process.env.VUE_APP_OSS_URL}${res.data.watermarkUrl}`;
      return (this.doctorCertificateSubmitDTO.idCard.front = `${process.env.VUE_APP_OSS_URL}${res.data.sourceUrl}`);
    },
    handleMessage4beforeRemove(file, fileList, index) {
      // if(this.doctorCertificateSubmitDTO.idCard.watermarkFiles.split(',').length - 1 < index){
      //  return;
      // }
      // let str = this.doctorCertificateSubmitDTO.idCard.watermarkFront.split(',').splice(index,1).join(',');
      this.doctorCertificateSubmitDTO.idCard.watermarkFront = "";
    },
    /**
     * @description: 上传资格证图片
     * @event:
     * @param {*}
     * @return {*}
     */
    certificateQualificationResponse(response) {
      if (response.code == 0) {
        // setTimeout(() => {
        // 	this.add()
        // }, 100)
        let a = `${process.env.VUE_APP_OSS_URL}${response.data.sourceUrl}`;
        if (
          this.doctorCertificateSubmitDTO.qualification.watermarkFiles == ""
        ) {
          this.doctorCertificateSubmitDTO.qualification.watermarkFiles =
            response.data.watermarkUrl;
        } else {
          let arr =
            this.doctorCertificateSubmitDTO.qualification.watermarkFiles.split(
              ","
            );
          arr.push(response.data.watermarkUrl);

          this.doctorCertificateSubmitDTO.qualification.watermarkFiles =
            arr.join(",");
        }

        return this.doctorCertificateSubmitDTO.qualification.files.push(a);
      }
    },
    certificateQualificationbeforeRemove(file, fileList, index) {
      // if(this.doctorCertificateSubmitDTO.qualification.watermarkFiles.split(',').length - 1 < index && !(this.doctorCertificateSubmitDTO.qualification.watermarkFiles.split(',').length === 1 && index===0)){
      //  return;
      // }
      let str =
        this.doctorCertificateSubmitDTO.qualification.watermarkFiles.split(",");
      str.splice(index, 1);
      this.doctorCertificateSubmitDTO.qualification.watermarkFiles =
        str.join(",");
    },
    /**
     * @description: 执业证上传
     * @event:
     * @param {*}
     * @return {*}
     */
    practiceUploadImage(response) {
      if (response.code == 0) {
        // setTimeout(() => {

        // 	this.add()
        // }, 100)
        if (this.doctorCertificateSubmitDTO.practice.watermarkFiles == "") {
          this.doctorCertificateSubmitDTO.practice.watermarkFiles =
            response.data.watermarkUrl;
        } else {
          let arr =
            this.doctorCertificateSubmitDTO.practice.watermarkFiles.split(",");
          arr.push(response.data.watermarkUrl);

          this.doctorCertificateSubmitDTO.practice.watermarkFiles =
            arr.join(",");
        }
        return this.doctorCertificateSubmitDTO.practice.files.push(
          `${process.env.VUE_APP_OSS_URL}${response.data.sourceUrl}`
        );
      }
    },
    practicebeforeRemove(file, fileList, index) {
      // if(this.doctorCertificateSubmitDTO.practice.watermarkFiles.split(',').length - 1 < index && !(this.doctorCertificateSubmitDTO.practice.watermarkFiles.split(',').length === 1 && index===0)){
      //  return;
      // }
      let str =
        this.doctorCertificateSubmitDTO.practice.watermarkFiles.split(",");
      str.splice(index, 1);
      this.doctorCertificateSubmitDTO.practice.watermarkFiles = str.join(",");
      // this.doctorCertificateSubmitDTO.practice.watermarkFiles = str;
    },
    /**
     * @description: 职称证上传
     * @event:
     * @param {*} e
     * @return {*}
     */
    certificatePracticeResponse(response) {
      if (response.code == 0) {
        // setTimeout(() => {
        // 	this.add()
        // }, 100)
        if (this.doctorCertificateSubmitDTO.title.watermarkFiles == "") {
          this.doctorCertificateSubmitDTO.title.watermarkFiles =
            response.data.watermarkUrl;
        } else {
          let arr =
            this.doctorCertificateSubmitDTO.title.watermarkFiles.split(",");
          arr.push(response.data.watermarkUrl);

          this.doctorCertificateSubmitDTO.title.watermarkFiles = arr.join(",");
        }
        return this.doctorCertificateSubmitDTO.title.files.push(
          `${process.env.VUE_APP_OSS_URL}${response.data.sourceUrl}`
        );
      }
    },
    certificatePracticebeforeRemove(file, fileList, index) {
      // if(this.doctorCertificateSubmitDTO.title.watermarkFiles.split(',').length - 1 < index && !(this.doctorCertificateSubmitDTO.title.watermarkFiles.split(',').length === 1 && index===0)){
      //  return;
      // }
      let str = this.doctorCertificateSubmitDTO.title.watermarkFiles.split(",");
      str.splice(index, 1);
      this.doctorCertificateSubmitDTO.title.watermarkFiles = str.join(",");
      // this.doctorCertificateSubmitDTO.title.watermarkFiles = str;
    },
    // 胸牌
    certificateNameBadgeResponse(response) {
      if (response.code == 0) {
        // setTimeout(() => {
        // 	this.add()
        // }, 100)
        if (this.doctorCertificateSubmitDTO.nameBadge.watermarkFiles == "") {
          this.doctorCertificateSubmitDTO.nameBadge.watermarkFiles =
            response.data.watermarkUrl;
        } else {
          let arr =
            this.doctorCertificateSubmitDTO.nameBadge.watermarkFiles.split(",");
          arr.push(response.data.watermarkUrl);

          this.doctorCertificateSubmitDTO.nameBadge.watermarkFiles =
            arr.join(",");
        }
        return this.doctorCertificateSubmitDTO.nameBadge.files.push(
          `${process.env.VUE_APP_OSS_URL}${response.data.sourceUrl}`
        );
      }
    },
    certificateNameBadgebeforeRemove(file, fileList, index) {
      // if(this.doctorCertificateSubmitDTO.title.watermarkFiles.split(',').length - 1 < index && !(this.doctorCertificateSubmitDTO.title.watermarkFiles.split(',').length === 1 && index===0)){
      //  return;
      // }
      let str =
        this.doctorCertificateSubmitDTO.nameBadge.watermarkFiles.split(",");
      str.splice(index, 1);
      this.doctorCertificateSubmitDTO.nameBadge.watermarkFiles = str.join(",");
      // this.doctorCertificateSubmitDTO.title.watermarkFiles = str;
    },
    /**
     * @description: 其他相关证书上传
     * @event:
     * @param {*} e
     * @return {*}
     */
    certificateOtherUplod(response) {
      if (response.code == 0) {
        // setTimeout(() => {
        // 	this.add()
        // }, 100)
        if (this.doctorCertificateSubmitDTO.other.watermarkFiles == "") {
          this.doctorCertificateSubmitDTO.other.watermarkFiles =
            response.data.watermarkUrl;
        } else {
          let arr =
            this.doctorCertificateSubmitDTO.other.watermarkFiles.split(",");
          arr.push(response.data.watermarkUrl);

          this.doctorCertificateSubmitDTO.other.watermarkFiles = arr.join(",");
        }
        return this.doctorCertificateSubmitDTO.other.files.push(
          `${process.env.VUE_APP_OSS_URL}${response.data.sourceUrl}`
        );
      }
    },
    certificateOtherbeforeRemove(file, fileList, index) {
      // if(this.doctorCertificateSubmitDTO.other.watermarkFiles.split(',').length - 1 < index && !(this.doctorCertificateSubmitDTO.other.watermarkFiles.split(',').length === 1 && index===0)){
      //  return;
      // }

      let str = this.doctorCertificateSubmitDTO.other.watermarkFiles.split(",");
      str.splice(index, 1);
      this.doctorCertificateSubmitDTO.other.watermarkFiles = str.join(",");
    },
    radioChangeGrounp(e) {
      // this.doctorTeamId = '';
      // if(e == false){
      // this.departmentList1 = [];//归属科室
      // this.caseMgrGroupList = [];//个案组列表
      this.doctorTeam.name = "";
      this.doctorTeam.id = "";
      this.doctorTeam.platformId = "";
      this.doctorTeam.departmentId = "";
      this.doctorTeam.caseMgrGroupId = "";
      this.doctorTeam.openDepartmentId = "";
    },
    doctorTeamChange(val) {
      this.doctorTeam.doctorTeamName = "";
      for (var i = 0; i < this.doctorTeamList.length; i++) {
        if (this.doctorTeamList[i].id == val) {
          this.doctorTeam.doctorTeamName = this.doctorTeamList[i].name;
        }
      }
    },
    departmentTeamChange() {
      this.doctorTeam.departmentName = "";
      this.$nextTick(() => {
        this.doctorTeam.departmentName =
          this.$refs["Mycascader1"].getCheckedNodes()[0].label;
      });
    },
    caseMgrGroupChange(val) {
      this.doctorTeam.caseMgrGroupName = "";
      for (var i = 0; i < this.caseMgrGroupList.length; i++) {
        if (this.caseMgrGroupList[i].id == val) {
          this.doctorTeam.caseMgrGroupName = this.caseMgrGroupList[i].name;
        }
      }
    },
    PreviousStep() {
      this.flagId = this.information1.hospitalId;
      this.activeName1 -= 1;
    },
    hospitalChange(val, b) {
      this.hospitalId = val;
      if (!b) {
        this.information1.departmentId = "";
      }
      if (this.information1.doctorType == 2) {
        // getHaveNursingService(val).then(res=>{
        // 	this.haveService = res.data
        // })
      }
      if (this.userPlatForm == "platForm") {
        this.getTreeList(
          this.userPlatForm == "platForm"
            ? this.information1.hospitalId
            : local.get("hospitalId")
        );
        if (this.information1.hospitalId) {
          getPlatformOpenDepartmentList({
            hospitalId: this.information1.hospitalId,
          }).then((res) => {
            if (res.code == 0) {
              this.departmentList1 = res.data;
            }
          });
        }
      } else {
        for (var i = 0; i < this.platformOptions.length; i++) {
          if (this.platformOptions[i].id == this.information1.hospitalId) {
            this.doctorTeam.platformName = this.platformOptions[i].name;
          }
        }
      }

      this.hospitalList.forEach((item) => {
        if (item.id == val) {
          this.doctorTeam.hospitalId = item.id;
          this.doctorTeam.hospitalName = item.name;
        }
      });

      this.information1.hospitalName = "";
      for (var i = 0; i < this.hospitalList.length; i++) {
        if (
          this.hospitalList[i].id == val ||
          this.hospitalList[i].id == this.information1.hospitalId
        ) {
          this.information1.hospitalName = this.hospitalList[i].name;
        }
      }
      this.doctorTeamList = [];
      this.doctorTeam.id = null;
      if (val != "") {
        this.apiDoctorTeamSearchinit(val);
      }
      this.getDepartList(val);
    },
    getDepartList(val) {
      api_department({ hospitalId: val }).then((res) => {
        if (res.code == 0) {
          this.departmentList = res.data;
        }
      });
    },
    institutionFlag(arr, newArr) {
      arr.forEach((item, index) => {
        newArr.forEach((el, i) => {
          if (item.id == el.hospitalId) {
            item.flag = true;
          }
        });
      });
      return arr;
    },
    hospitalChangeNew(e, val) {
      this.hospitalList.forEach((item, i) => {
        item.flag = false;
      });
      // this.information1.hospitalList[val].departmentList = [];
      // this.information1.hospitalList[val].departmentId = []
      // this.information1.hospitalList[val].openDepartmentIdList = []
      this.hospitalList = this.institutionFlag(
        this.hospitalList,
        this.information1.hospitalList
      );
      if (this.information1.doctorType == 2) {
        // getHaveNursingService(val).then(res=>{
        // 	this.haveService = res.data
        // })
      }
      if (this.userPlatForm == "platForm") {
        this.getTreeList(
          this.userPlatForm == "platForm"
            ? this.information1.hospitalList[val].hospitalId
            : local.get("hospitalId")
        );
        if (this.information1.hospitalList[val].hospitalId) {
          getPlatformOpenDepartmentList({
            hospitalId: this.information1.hospitalList[val].hospitalId,
          }).then((res) => {
            if (res.code == 0) {
              this.departmentList1 = res.data;
            }
          });
        }
      } else {
        for (var i = 0; i < this.platformOptions.length; i++) {
          if (
            this.platformOptions[i].id ==
            this.information1.hospitalList[val].hospitalId
          ) {
            this.doctorTeam.platformName = this.platformOptions[i].name;
          }
        }
      }
      this.hospitalList.forEach((item) => {
        if (item.id == this.information1.hospitalList[val].hospitalId) {
          this.doctorTeam.hospitalId = item.id;
          this.doctorTeam.hospitalName = item.name;
          this.information1.hospitalList[val].hospitalName = item.name;
        }
      });

      this.information1.hospitalName = "";
      for (var i = 0; i < this.hospitalList.length; i++) {
        if (
          this.hospitalList[i].id ==
          this.information1.hospitalList[val].hospitalId
        ) {
          this.information1.hospitalName = this.hospitalList[i].name;
          this.information1.hospitalList[val].hospitalName =
            this.hospitalList[i].name;
        }
      }
      this.apiDoctorTeamSearchinitNew(
        val,
        this.information1.hospitalList[val].hospitalId
      );
      if (this.dialogVisible) {
        this.information1.departmentId = "";
      }
      this.information1.hospitalList[val].departmentId = [];
      this.information1.hospitalList[val].openDepartmentIdList = [];

      if (e != "") {
        this.information1.hospitalList[val].departmentList = [];
        api_department({
          hospitalId: this.information1.hospitalList[val].hospitalId,
        }).then((res) => {
          if (res.code == 0) {
            // this.departmentList = res.data;
            // this.information1.hospitalList[val].departmentList = res.data;
            let obj = this.information1.hospitalList[val];
            obj.departmentList = res.data;
            this.$set(this.information1.hospitalList, val, obj);
            // this.information1.hospitalList[val].departmentList = res.data;
          }
        });
        // this.$forceUpdate();
      }
      this.btnFlag = false;
      if (this.information1.platformAssist && e != "") {
        if (this.userPlatForm == "organization") {
          this.joinedTeamList = [];
          getListByHospitalId({
            hospitalId: local.get("hospitalId"),
          }).then((res) => {
            console.log(res, "ressss");
            if (res.code == 0) {
              this.joinedTeamList = this.joinedTeamList.concat(res.data);
            } else {
              // this.joinedTeamList = [];
            }
          });
        } else {
          // getListByHospitalId({
          //   hospitalId: this.information1.hospitalList[val].hospitalId
          // }).then(res => {
          //   console.log(res, "ressss");
          //   if (res.code == 0) {
          //     this.joinedTeamList = res.data;
          //   } else {
          //     // this.joinedTeamList = [];
          //   }
          // });
        }
      }
      console.log(this.information1.hospitalList, "切换的值");
    },
    confirmClick() {
      let flag = true;
      this.information1.hospitalList.forEach((item, index) => {
        if (item.hospitalId == null) {
          flag = false;
        }
      });
      if (flag == false) {
        this.$message.error("请选择线下机构");
        return false;
      }
      this.joinedTeamList = [];
      this.information1.hospitalList.forEach((item) => {
        getListByHospitalId({
          hospitalId: item.hospitalId,
        }).then((res) => {
          if (res.code == 0) {
            this.joinedTeamList = this.joinedTeamList.concat(res.data);
          }
        });
      });
      this.btnFlag = true;
    },
    apiDoctorTeamSearchinitNew(index, id) {
      let val = id ? id : null;
      api_doctor_team({
        disabled: false,
        hospitalId: val,
      }).then((res) => {
        this.doctorTeamList = res.data;
      });
    },
    departmentChange(val) {
      this.information1.departmentName = "";
      if (!this.$refs["Mycascader"].getCheckedNodes().length) {
        return;
      }
      this.$nextTick(() => {
        this.information1.departmentName =
          this.$refs["Mycascader"].getCheckedNodes()[0].label;
      });
    },
    departmentChangeNew(e, val) {
      // this.information1.departmentName = "";
      this.information1.hospitalList[val].openDepartmentIdList = [];

      if (!this.$refs[`Mycascader${val}`][0].getCheckedNodes().length) {
        return;
      }
      // this.$nextTick(() => {
      this.information1.hospitalList[val].departmentName =
        this.$refs[`Mycascader${val}`][0].getCheckedNodes()[0].label;

      // });
      console.log(
        this.information1.hospitalList[val].departmentId instanceof Array,
        "this.information1.hospitalList[val].departmentId"
      );
      if (this.information1.hospitalList[val].departmentId instanceof Array) {
        this.information1.hospitalList[val].departmentId.forEach(
          (item, index) => {
            //获取科室二级
            let obj = { openDepartmentId: null, openDepartmentName: null };
            if (
              this.information1.hospitalList[val].departmentList &&
              this.information1.hospitalList[val].departmentList.length > 0
            ) {
              this.information1.hospitalList[val].departmentList.forEach(
                (el, i) => {
                  if (el.children && el.children.length > 0) {
                    el.children.forEach((itemEl, itemI) => {
                      if (itemEl.id == item) {
                        obj.openDepartmentId = itemEl.id;
                        obj.openDepartmentName = itemEl.name;
                        this.information1.hospitalList[
                          val
                        ].openDepartmentIdList.push(obj);
                      }
                    });
                  } else {
                    if (el.id == item) {
                      obj.openDepartmentId = el.id;
                      obj.openDepartmentName = el.name;
                      this.information1.hospitalList[
                        val
                      ].openDepartmentIdList.push(obj);
                    }
                  }
                }
              );
            }
          }
        );
      } else {
        let obj = { openDepartmentId: null, openDepartmentName: null };
        this.information1.hospitalList[val].departmentList.forEach(
          (el, index) => {
            if (el.children && el.children.length > 0) {
              el.children.forEach((itemEl, itemI) => {
                if (
                  itemEl.id == this.information1.hospitalList[val].departmentId
                ) {
                  obj.openDepartmentId = itemEl.id;
                  obj.openDepartmentName = itemEl.name;
                  this.information1.hospitalList[
                    val
                  ].openDepartmentIdList.unshift(obj);
                }
              });
            } else {
              if (el.id == this.information1.hospitalList[val].departmentId) {
                obj.openDepartmentId = el.id;
                obj.openDepartmentName = el.name;
                this.information1.hospitalList[
                  val
                ].openDepartmentIdList.unshift(obj);
              }
            }
          }
        );
      }

      // departmentId;
      console.log(
        this.information1.hospitalList,
        "this.information1.hospitalList"
      );
    },
    departmentChangeNewMent(e, val) {
      this.information1.hospitalList[val].openDepartmentIdList = [];

      if (!this.$refs[`Mycascader${val}`][0].getCheckedNodes().length) {
        return;
      }
      // this.$nextTick(() => {
      this.information1.hospitalList[val].departmentName =
        this.$refs[`Mycascader${val}`][0].getCheckedNodes()[0].label;

      // });
      let obj = { openDepartmentId: null, openDepartmentName: null };
      this.information1.hospitalList[val].departmentList.forEach(
        (el, index) => {
          if (el.children && el.children.length > 0) {
            el.children.forEach((itemEl, itemI) => {
              if (
                itemEl.id == this.information1.hospitalList[val].departmentId
              ) {
                obj.openDepartmentId = itemEl.id;
                obj.openDepartmentName = itemEl.name;
                this.information1.hospitalList[
                  val
                ].openDepartmentIdList.unshift(obj);
              }
            });
          } else {
            if (el.id == this.information1.hospitalList[val].departmentId) {
              obj.openDepartmentId = el.id;
              obj.openDepartmentName = el.name;
              this.information1.hospitalList[val].openDepartmentIdList.unshift(
                obj
              );
            }
          }
        }
      );
    },
    apiDoctorTeamSearchinit(id) {
      let val = id ? id : null;
      api_doctor_team({
        disabled: false,
        hospitalId: val,
      }).then((res) => {
        this.doctorTeamList = res.data;
      });
    },
    getTreeList(id) {
      treeList({
        type: 2,
        hospitalId: this.hospitalId,
      }).then((res) => {
        if (res.code == 0) {
          this.caseMgrGroupList = res.data;
        }
      });
    },
    getPlatformListHandel() {
      // {disabled:false}
      getPlatformList({ disabled: false }).then((res) => {
        if (res.code == 0) {
          this.platformOptions = res.data;
        }
      });
    },
    submiAddCare1(ref) {
      this.$refs[ref].validate(async (valid) => {
        if (valid) {
          if (!this.upavater) return this.$message.error("请上传医生照片");
          console.log(!this.btnFlag, "!this.btnFlag");
          console.log(
            this.information1.platformAssist,
            "this.information1.platformAssist"
          );
          if (!this.btnFlag && this.information1.platformAssist == 1) {
            this.$message.error("请点击确认，刷新归属团队");
            return false;
          }
          checkIdCardNumber(
            this.information1.idCard,
            this.information1.realName
          ).then((res) => {
            // if(this.information1.doctorType == 4) {
            // 	this.newSelectTteam = false;
            // }
            // if(this.information1.doctorType == 6) {
            // 	this.newSelectTteam = false;
            // }
            // this.activeName1 = 1;
            this.submiAddCare2();
          });
          // if(this.information1.hospitalId != this.flagId || this.userPlatForm == 'organization'){
          // 	this.doctorTeam.id = ''
          // 	this.doctorTeam.platformName='';
          // 	for (var i = 0; i < this.platformOptions.length; i++) {
          // 		if(this.platformOptions[i].id==this.information1.hospitalId){
          // 			this.doctorTeam.platformName = this.platformOptions[i].name;
          // 		}
          // 	}
          // 	// doctorTeam.platformId
          // 	this.departmentList1 = [];//归属科室
          // 	this.caseMgrGroupList = [];//个案组列表
          // 	this.doctorTeam.departmentId = '';
          // 	this.getTreeList(this.userPlatForm == 'platForm' ? this.information1.hospitalId : local.get('hospitalId'))
          // getPlatformOpenDepartmentList({
          // 	hospitalId: this.userPlatForm == 'platForm' ? this.information1.hospitalId : local.get('hospitalId')
          // }).then((res) => {
          // 	if (res.code == 0) {
          // 		this.departmentList1 = res.data;
          // 	}
          // })
          // }
        } else {
        }
      });
    },
    submiAddCare2() {
      if (this.newSelectTteam) {
        if (this.doctorTeam.type == 1) {
          if (!this.doctorTeam.id) {
            return this.$message.error("请选择团队");
          }
        } else {
          if (!this.doctorTeam.name) {
            return this.$message.error("请输入团队名称");
          }
          if (!this.doctorTeam.hospitalId && this.userPlatForm == "platForm") {
            return this.$message.error("请选择线下机构");
          }
          if (!this.doctorTeam.openDepartmentId) {
            return this.$message.error("请选择线下科室");
          }
          if (!this.doctorTeam.caseMgrGroupId) {
            return this.$message.error("请选择个案组");
          }
        }
      }
      if (this.newSelectTteam === "" && this.information1.doctorType != 4) {
        return this.$message.info("请选择是否归属团队");
      }
      this.activeName1 = 2;
    },
    closeaddCare2() {
      if (this.information1.doctorType != 4) {
        this.newSelectTteam = "";
        this.doctorTeam.type = "";
        this.isMdt = false;
        this.doctorTeam.id = "";
        this.doctorTeam.doctorTeamName = "";
        this.doctorTeam.name = "";
        this.doctorTeam.departmentId = "";
        this.doctorTeam.departmentName = "";
        this.doctorTeam.platformId = "";
        this.doctorTeam.platformName = "";
        this.doctorTeam.caseMgrGroupName = "";
      }
    },
    closeaddCare3() {
      // if(this.information1.doctortype !== 4){
      this.doctorCertificateSubmitDTO.idCard = {
        back: "",
        front: "",
        watermarkBack: "",
        watermarkFront: "",
      };
      (this.doctorCertificateSubmitDTO.other = {
        files: [],
        watermarkFiles: "",
      }),
        (this.doctorCertificateSubmitDTO.practice = {
          files: [],
          number: "",
          obtainDate: "",
          watermarkFiles: "",
        }),
        (this.doctorCertificateSubmitDTO.qualification = {
          files: [],
          obtainDate: "",
          number: "",
          watermarkFiles: "",
        });
      this.doctorCertificateSubmitDTO.title = {
        files: [],
        obtainDate: "",
        number: "",
        watermarkFiles: "",
      };
      this.doctorCertificateSubmitDTO.nameBadge = {
        files: [],
        fileList: [],
        obtainDate: "",
        number: "",
        watermarkFiles: "",
      };
    },
    getPlatformListInit() {
      getPlatformList({}).then((res) => {
        if (res.code == 0) {
          this.platformList.hospitalList = res.data;
        }
      });
    },
    closeaddCare1() {
      this.information1 = this.$options.data().information1;
      this.upavater = "";
      this.doctorTitleList = [];
    },
    redioChange() {
      this.information1.serviceScopeKm = "";
    },
    closeaddCare2() {
      // if(this.information1.doctorType != 4){
      this.newSelectTteam = "";
      this.doctorTeam.type = "";
      this.isMdt = false;
      this.doctorTeam.id = "";
      this.doctorTeam.doctorTeamName = "";
      this.doctorTeam.name = "";
      this.doctorTeam.departmentId = "";
      this.doctorTeam.departmentName = "";
      this.doctorTeam.platformId = "";
      this.doctorTeam.platformName = "";
      this.doctorTeam.caseMgrGroupName = "";
      // }
    },
    doctorTitleChange(v) {
      this.information1.titleName = "";
      for (var i = 0; i < this.doctorTitleList.length; i++) {
        if (this.doctorTitleList[i].id == v) {
          this.information1.titleName = this.doctorTitleList[i].name;
        }
      }
    },
    selectDoctorType(e) {
      this.getDoctorTitle(e);
      // if (e == 2) {
      this.information1.serviceScopeKm = "";
      (this.information1.note = ""), //介绍
        (this.information1.departmentId = ""); //科室ID
      this.information1.departmentName = ""; //科室ID
      this.information1.titleId = ""; //科室ID
      // this.information1.titleName = ""; //科室ID
      this.information1.professional = ""; //专业擅长
      this.information1.hospitalId = ""; //医院ID
      this.information1.hospitalName = "";
      this.information1.serviceScopeKm = ""; //上门服务km
      if (e == 2) {
        this.information1.provideNursingService = true;
      }
      if (e != 6) {
        this.institutionList = [
          {
            hospitalId: null,
            hospitalName: null,
            departmentId: null,
            departmentName: null,
            departmentList: [],
            openList: [],
          },
        ];
      }
      // this.$refs['addForm'].clearValidate();
      this.closeaddCare2();
      this.closeaddCare3();
      // }
    },
    getDoctorTitle(t) {
      doctor_title(t).then((res) => {
        if (res.code == 0) {
          this.doctorTitleList = res.data;
        }
      });
    },
    handleMessageResponse1(response) {
      if (response.code == 0) {
        return (this.information.photoUrl =
          `${process.env.VUE_APP_OSS_URL}` + response.data);
      }
    },

    handleMessageResponse2(response) {
      if (response.code == 0) {
        return (this.upavater = `${process.env.VUE_APP_OSS_URL}${response.data}`);
      }
    },
    handleMessageResponse3(res) {
      if (res.code !== 0) {
        return;
      }
      this.doctorCertificateSubmitDTO.idCard.watermarkBack = `${process.env.VUE_APP_OSS_URL}${res.data.watermarkUrl}`;
      return (this.doctorCertificateSubmitDTO.idCard.back = `${process.env.VUE_APP_OSS_URL}${res.data.sourceUrl}`);
    },
    getEntityHospital() {
      api_hospital({}).then((res) => {
        if (res.code == 0) {
          this.hospitalList = res.data.map((item, index) => {
            return {
              ...item,
              flag: false,
            };
          });
          // if (this.$route.query.id) {
          // 	this.formInline.hospitalId = this.$route.query.id;
          // }
        }
      });
    },
    getdetail(data, optionBtn) {
      const machiningFiles = (filesName, type) => {
        if (type)
          return filesName
            .split(",")
            .map((sub) => `${process.env.VUE_APP_OSS_URL}` + sub);
        else return filesName.split(",").toString();
      };

      getDoctor(data ? data : this.$route.query.id).then((res) => {
        this.$nextTick(() => {
          // DOM 更新了
          // this.$refs["addForm"].clearValidate()

          if (res.data.hospitalId)
            this.hospitalChange(res.data.hospitalId, true);
          // 原图
          if (res.data.masterPhotoUrl) {
            this.upavater =
              process.env.VUE_APP_OSS_URL + res.data.masterPhotoUrl;
          } else {
            // 裁剪图
            this.upavater = !!res.data.photoUrl
              ? process.env.VUE_APP_OSS_URL + res.data.photoUrl
              : "";
          }
          console.log("数据", res);
          this.certificateStatus = res.data.certificateStatus;
          this.hospitalObj = res.data.hospital;
          this.information1.sourceType = res.data.sourceType;
          this.information1.mobile = res.data.phone;
          this.information1.realName = res.data.name; //姓名
          this.information1.diseaseTypeNames = res.data.diseaseTypeNames;

          this.information1.sharingPicUrl = !!res.data.sharingPicUrl
            ? process.env.VUE_APP_OSS_URL + res.data.sharingPicUrl
            : "";
          this.information1.serviceWishes = res.data.serviceWishes
            ? res.data.serviceWishes
            : "";
          this.information1.diseaseServingDTOList = res.data
            .diseaseServingDTOList
            ? res.data.diseaseServingDTOList
            : [];
          (this.information1.idCard = res.data.idCardNumber
            ? res.data.idCardNumber
            : ""), //证件 号码
            (this.information1.idCardNumber = res.data.idCardNumber
              ? res.data.idCardNumber
              : "");
          this.information1.userId = res.data.userId;
          this.information1.sourceType = res.data.sourceType;
          this.information1.id = res.data.id;
          // this.information1.photoUrlCopy = "";//用来展示图片
          (this.information1.note = res.data.introduction), //介绍
            (this.information1.departmentId = res.data.departmentId); //科室ID
          this.information1.departmentName = res.data.departmentName;
          this.information1.doctorType = res.data.doctorType; //医护类型1.医生,2.护士,3.医技,4.药师
          this.getDoctorTitle(res.data.doctorType);
          this.information1.hospitalId = res.data.hospitalId; //医院ID
          this.information1.hospitalName = res.data.hospitalName;
          this.information1.professional = res.data.professional; //专业擅长
          this.information1.titleId = res.data.titleId; //职称ID
          this.information1.titleName = res.data.titleName;
          this.information1.serviceScopeKm = res.data.serviceScopeKm; //上门服务km
          this.information1.certificateStatus = res.data.certificateStatus; //平台医辅
          this.information1.provideNursingService =
            res.data.provideNursingService;
          if (res.data.platformAssist != null) {
            if (res.data.platformAssist == true) {
              this.information1.platformAssist = "1";
            } else {
              this.information1.platformAssist = "0";
            }
          }
          console.log(res.data.platformAssist, "是否平台医辅");
          if (res.data.hospitalList && res.data.hospitalList.length) {
            this.information1.hospitalListNew = res.data.hospitalList;
            // this.information1.hospitalId = res.data.hospitalList[0].hospitalId;
            // this.getDepartList(this.information1.hospitalId)
            this.information1.hospitalList = res.data.hospitalList;

            this.hospitalListBackup = JSON.parse(
              JSON.stringify(res.data.hospitalList)
            );
            // this.hospitalListBackup = res.data.hospitalList;

            console.log(res.data.hospitalList, "res.data.hospitalList");

            let queue = [];

            res.data.hospitalList.forEach((item, index) => {
              // item.departmentId = [];
              this.$set(item, "departmentId", []);
              // this.departmentFun(index);
              queue.push(this.departmentFun(index));
              if (
                item.openDepartmentIdList &&
                item.openDepartmentIdList.length > 0
              ) {
                item.openDepartmentIdList.forEach((el, i) => {
                  // item.departmentId.unshift(el.openDepartmentId);
                  item.departmentId.push(el.openDepartmentId);
                });
              }
              // this.departmentFun(index);
            });
            Promise.all(queue).then((result) => {
              // result.length == res.data.hospitalList.length &&
              // 保存获取数据，等拿到数据改变状态
              if (optionBtn == "save") {
                this.isEdit1 = false;
              }
            });
            // let arr = res.data.hospitalList;

            // arr.forEach((item, index) => {
            //   setTimeout(() => {
            //     this.information1.hospitalList.push(item);
            //   }, 1000);
            // });
            // this.userPlatForm == "organization"
            this.hospitalList = this.institutionFlag(
              this.hospitalList,
              this.information1.hospitalList
            );
            if (this.userPlatForm == "organization") {
              let arr = [];
              this.information1.hospitalList.forEach((item, index) => {
                if (item.hospitalId == local.get("hospitalId")) {
                  arr.push(item);
                }
              });
              this.information1.hospitalList = arr;
              this.information1.hospitalListNew = arr;
            }
            if (!res.data.platformAssist) {
              this.information1.hospitalList.forEach((item, index) => {
                item.departmentId = item.departmentId[0].toString();
              });
              console.log(this.information1.hospitalList, "qqq");
            }
            console.log(
              this.information1.hospitalList,
              "this.information1.hospitalListaa"
            );
            // this.hospitalListBackup = JSON.parse(JSON.stringify(this.information1.hospitalList));
            // this.hospitalListBackup = this.information1.hospitalList;
            console.log(this.hospitalListBackup, "this.hospitalListBackup");
            this.$forceUpdate();
          } else {
            this.information1.hospitalList = [
              {
                hospitalId: null,
                hospitalName: null,
                departmentId: null,
                departmentName: null,
                departmentList: [],
                openList: [],
              },
            ];
          }

          this.joinedTeamList = res.data.joinedTeamList
            ? res.data.joinedTeamList
            : [];
          if (res.data.certificateIdCard != null) {
            this.doctorCertificateSubmitDTO.idCard.back = `${process.env.VUE_APP_OSS_URL}${res.data.certificateIdCard.back}`;
            this.doctorCertificateSubmitDTO.idCard.watermarkBack = `${process.env.VUE_APP_OSS_URL}${res.data.certificateIdCard.watermarkBack}`;
            this.doctorCertificateSubmitDTO.idCard.front = `${process.env.VUE_APP_OSS_URL}${res.data.certificateIdCard.front}`;
            this.doctorCertificateSubmitDTO.idCard.watermarkFront = `${process.env.VUE_APP_OSS_URL}${res.data.certificateIdCard.watermarkFront}`;
          }
          //拷贝资格证信息
          if (
            res.data.certificateQualification != null &&
            res.data.certificateQualification.fileList.length > 0
          ) {
            this.doctorCertificateSubmitDTO.qualification.watermarkFiles =
              res.data.certificateQualification.watermarkFiles;
            this.doctorCertificateSubmitDTO.qualification.files =
              machiningFiles(res.data.certificateQualification.files, 1);
            this.doctorCertificateSubmitDTO.qualification.fileList =
              res.data.certificateQualification.fileList.map((item) => {
                return process.env.VUE_APP_OSS_URL + item;
              });
          }
          if (
            res.data.certificateQualification != null &&
            res.data.certificateQualification.number
          ) {
            this.doctorCertificateSubmitDTO.qualification.number =
              res.data.certificateQualification.number;
          }
          if (
            res.data.certificateQualification != null &&
            res.data.certificateQualification.getDate
          ) {
            this.doctorCertificateSubmitDTO.qualification.obtainDate =
              res.data.certificateQualification.getDate;
          }
          //拷贝执业证信息
          if (
            res.data.certificatePractice != null &&
            res.data.certificatePractice.fileList.length > 0
          ) {
            this.doctorCertificateSubmitDTO.practice.watermarkFiles =
              res.data.certificatePractice.watermarkFiles;
            this.doctorCertificateSubmitDTO.practice.files = machiningFiles(
              res.data.certificatePractice.files,
              1
            );
            this.doctorCertificateSubmitDTO.practice.fileList =
              res.data.certificatePractice.fileList.map((item) => {
                return process.env.VUE_APP_OSS_URL + item;
              });
          }
          if (
            res.data.certificatePractice != null &&
            res.data.certificatePractice.number
          ) {
            this.doctorCertificateSubmitDTO.practice.number =
              res.data.certificatePractice.number;
          }
          if (
            res.data.certificatePractice != null &&
            res.data.certificatePractice.getDate
          ) {
            this.doctorCertificateSubmitDTO.practice.obtainDate =
              res.data.certificatePractice.getDate;
          }
          //拷贝职业证信息
          if (
            res.data.certificateTitle != null &&
            res.data.certificateTitle.fileList.length > 0
          ) {
            this.doctorCertificateSubmitDTO.title.watermarkFiles =
              res.data.certificateTitle.watermarkFiles;
            this.doctorCertificateSubmitDTO.title.files = machiningFiles(
              res.data.certificateTitle.files,
              1
            );
            this.doctorCertificateSubmitDTO.title.fileList =
              res.data.certificateTitle.fileList.map((item) => {
                return process.env.VUE_APP_OSS_URL + item;
              });
          }
          //拷贝胸牌
          if (
            res.data.certificateNameBadge != null &&
            res.data.certificateNameBadge.fileList.length > 0
          ) {
            this.doctorCertificateSubmitDTO.nameBadge.watermarkFiles =
              res.data.certificateNameBadge.watermarkFiles;
            this.doctorCertificateSubmitDTO.nameBadge.files = machiningFiles(
              res.data.certificateNameBadge.files,
              1
            );
            this.doctorCertificateSubmitDTO.nameBadge.fileList =
              res.data.certificateNameBadge.fileList.map((item) => {
                return process.env.VUE_APP_OSS_URL + item;
              });
            this.$forceUpdate();
          }

          //拷贝其他相关
          if (
            res.data.certificateOther != null &&
            res.data.certificateOther.fileList.length > 0
          ) {
            this.doctorCertificateSubmitDTO.other.watermarkFiles =
              res.data.certificateOther.watermarkFiles;
            this.doctorCertificateSubmitDTO.other.files = machiningFiles(
              res.data.certificateOther.files,
              1
            );
            this.doctorCertificateSubmitDTO.other.fileList =
              res.data.certificateOther.fileList.map((item) => {
                return process.env.VUE_APP_OSS_URL + item;
              });
          }

          // if (res.code == 0) {
          //   this.getListByDoctorIdInit();
          //   //有实体平台的时候，需要根据hospitalId进行查询下级实体科室列表
          // }
        });
      });
    },
    /**
     * @description: 根据医生ID查询平台列表
     * @param {*}
     * @return {*}
     */
    // getListByDoctorIdInit() {
    //   getListByDoctorId(this.information1.id).then(res => {
    //     if (res.code == 0) {
    //       this.platformList.tableData = res.data;
    //     }
    //   });
    // }
    addHospitalId() {
      let obj = {
        hospitalId: null,
        hospitalName: null,
        departmentId: null,
        departmentName: null,
        departmentList: [],
        openDepartmentIdList: [],
      };
      // this.institutionList.push(obj);
      this.information1.hospitalList.push(obj);
    },
    deleteClick(index) {
      this.hospitalList.forEach((item, i) => {
        item.flag = false;
      });
      let id = this.information1.hospitalList[index].hospitalId;
      this.delBolognTeam(id);
      this.information1.hospitalList.splice(index, 1);
      this.hospitalList = this.institutionFlag(
        this.hospitalList,
        this.information1.hospitalList
      );
    },
    delBolognTeam(hospitalId) {
      let delIndex = [];
      this.joinedTeamList.map((item, index) => {
        if (item.teamHospitalId == hospitalId) {
          delIndex.push(index);
        }
      });
      if (delIndex.length > 0) {
        for (let i = delIndex.length - 1; i >= 0; i--) {
          this.joinedTeamList.splice(delIndex[i], 1);
        }
      }
      // console.log("存在的归属团队", this.joinedTeamList);
    },
    // 回显科室
    departmentFun(val) {
      return new Promise((resolve) => {
        api_department({
          hospitalId: this.information1.hospitalList[val].hospitalId,
        }).then((res) => {
          if (res.code == 0) {
            // this.departmentList = res.data;
            this.information1.hospitalList[val].departmentList = res.data;
            resolve(1);
          }
        });
      });
    },
    platformAssistChange(e) {
      console.log(e);
      if (e == 1) {
      } else {
        this.joinedTeamList = [];
        this.information1.hospitalList = [
          {
            hospitalId: null,
            hospitalName: null,
            departmentId: null,
            departmentName: null,
            departmentList: [],
            openDepartmentIdList: [],
          },
        ];
      }
    },
  },
  created() {
    this.VUE_APP_BASE_URL = "/api/dsicm-contact-platform/feign/file/upload";
    this.VUE_APP_BASE_URL1 =
      "/api/dsicm-contact-platform/feign/file/uploadWatermark";
    this.getEntityHospital(); //获取实体医院列表
    // this.getDoctorTitle(); //获取职称段位
    // this.getPlatformListInit()

    this.getdetail();
    this.getPlatformListHandel();
    getStrategicDiseaseAndWechat().then((res) => {
      this.diseaseList = res.data.map((item) => {
        return {
          ...item,
          diseaseTypeId: item.diseaseId,
          diseaseTypeName: item.diseaseName,
          mediaId: "",
        };
      });
    });
    if (this.userPlatForm == "organization") {
      this.apiDoctorTeamSearchinit(local.get("hospitalId"));
      this.getTreeList(local.get("hospitalId"));
      getPlatformOpenDepartmentList({
        hospitalId: local.get("hospitalId"),
      }).then((res) => {
        if (res.code == 0) {
          this.departmentList1 = res.data;
        }
      });
    } else {
      this.apiDoctorTeamSearchinit();
    }
  },
  mounted() {},
};
</script>
<style lang="less" scoped>
.box {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.user-id {
  display: inline-block;
  margin-left: 40px;
  font-weight: bold;
  font-size: 14px;
  vertical-align: middle;
}
/deep/.self-scroll {
  margin-bottom: 20px;

  .is-vertical {
    background: #f1f1f1;
    margin-bottom: 10px;

    div {
      background: #c1c1c1;
    }
  }
}

/deep/.el-select {
  width: 100%;
}

/deep/.el-cascader {
  width: 100%;
}

.header {
  background: #fff;

  .text {
    padding: 24px;
    color: #333333;
    font-size: 14px;
    line-height: 22px;
    padding-bottom: 20px;

    // border-bottom: 16px solid #F8F8F8;
    span:nth-child(2) {
      color: #333;
    }

    span:nth-child(1) {
      color: #999;
    }
  }

  .top-tabs {
    // display: flex;
    // width: 600px;
    padding-left: 24px;
    // padding-top: 40px;

    div {
      cursor: pointer;
      vertical-align: top;
      display: inline-block;
      line-height: 26px;
      &:hover{
        color: #1a7bfc;
      }
    }

    .tabs-cliked {
      color: #1a7bfc;

      span {
        padding-bottom: 4px;
        border-bottom: 2px solid #1a7bfc;
      }
    }

    div:nth-of-type(2) {
      // min-width: 275px;
      margin-left: 64px;
    }

    div:last-of-type {
      min-width: 275px;
      margin-left: 64px;
    }
  }
}

.content {
  margin: 15px;
  padding: 10px 20px;
  background: #fff;

  .team-item {
    margin-left: 40px;
    margin-bottom: 20px;

    h3 {
      margin-bottom: 30px;
      font-size: 14px;
    }

    ul {
      display: flex;
      width: 100%;

      li {
        flex: 1;
        font-size: 12px;
        display: flex;

        label {
          white-space: nowrap;
          margin-right: 20px;
        }
      }
    }
  }

  .tip-zhengshu {
    color: #999999;
  }

  .label-circle {
    display: flex;
    margin-bottom: 10px;
    height: 25px;
    align-items: center;
    width: 128px;
    flex-flow: row-reverse;

    span:nth-of-type(2) {
      margin-right: 10px;
      width: 6px;
      height: 6px;
      background: #d0e4ff;
      border-radius: 50%;
    }
  }

  .line-div {
    margin: 0px 0 30px;

    span:nth-of-type(1) {
      display: inline-block;
      width: 4px;
      height: 14px;
      background: #1a7bfc;
      margin-right: 10px;
      vertical-align: middle;
    }

    span:nth-of-type(2) {
      font-weight: bold;
      font-size: 14px;
      vertical-align: middle;
    }
  }

  .dialog-footer {
    padding: 20px;
    display: block;
  }

  .dialog-footer {
    display: block;
    margin-top: 10px;
    padding: 5px 0 10px;
    text-align: center;

    .dialog-btn {
      width: 110px;
      height: 32px;
    }
  }
}

.no-div {
  margin: 125px auto 20px;
  text-align: center;

  p {
    margin-top: 20px;
  }
}

.form-box {
  line-height: 28px;

  /deep/.el-form-item__label {
    line-height: 24px !important;
  }

  /deep/.el-form-item__content {
    line-height: 24px !important;
  }
}

.mb10 {
  margin-bottom: 0 !important;
}
</style>